import React from 'react';
import {
    Space, Row, Col, Select, Descriptions, message, Button, Form, ConfigProvider, Anchor, Input, Modal, Skeleton, Spin, DatePicker,
    Radio, InputNumber
} from 'antd';
import { RightOutlined, CheckCircleTwoTone, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import Headline from "../Headline/Headline.jsx"
import { APIService } from '../../../services/commission/api.js';
import reactDialog from '../../../lib/editableDialog.js';
// import ProductPageon from "../../../../components/bisystem/canvas/main/cells/cell/calendar/cell.calendar.html"
import zhCN from 'antd/es/locale/zh_CN';
import 'antd/dist/antd.css';
import './PagePanel.scss'
import moment from 'moment';
import 'moment/locale/zh-cn';
// import { Input } from 'element-react';
const { Link } = Anchor;
const { Option } = Select;
class PagePanel extends React.Component {

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            currentlist: [],
            approveShow: false,//审批驳回按钮
            isModalVisible: false, //引用按钮打开界面
            isEdit: this.props.data.isEdit,
            editable: this.props.data.editable ? this.props.data.editable : false,
            formData: [],
            info: {},
            BoxType: '', // 引用选用的项目

            project_typeL: '名称', // 项目类型
            choice: '', // 选择的项目
            choice_number: '', // 选择项目的编号
            name_platform: '通用平台', // 平台名称
            table_name: '0', // 表格名称

            listItems: [
                // { name: '睿信稳健配置2号TOF金融投资集合', project_id: "123456" }
            ],

            formlist: {}, // 筛选后的初始form对象
            editloading: false,
            admonish: false, // 提醒框显示
            valueOfthe: '', // 预存之前的选项
            platform: '', // 预存之前的选项

            SubmissionProcess: false, // 提交遮罩

            // 显示顺序---基础信息 
            orderingList: {
                "产品基本信息": [
                    '项目简称', '项目编号', '产品名称','预推送系列产品业务编号', '产品代码','私募类型','Ta代码','投资地区','机构端产品风险等级','产品规模', '产品结算货币代码',
                    '产品结算货币市场','管理公司代码','管理公司名称','托管机构名称','存续期是否开放', "募集开始日", "募集结束日","产品成立日/计划起点", '产品到期日/计划终点',
                    '份额明细展示','持仓展示分类','产品期限单位', '产品期限', '发行机构', '收益统计分类','是否允许提前结束', '计息基数','认购总控','申购总控','赎回总控',
                    '首次购买金额','认购单位', '认购单笔下限', '认购单笔上限','认购每日上限','赎回单位','赎回单笔下限', '赎回单笔上限', '赎回余额下限','强赎资金清算速度(日)','分红资金清算速度(日)',
                    '产品收益类型','业绩比较基准(%)','业绩比较基准（区间低）（%）','业绩比较基准（区间高）（%）','资管新规分类','赎回资金清算速度(日)','申购单位','申购每日上限',
                    '申购单笔下限','申购单笔上限','定投总控','定投投资单位','定投单笔上限','定投单笔下限','定投开放周期','固定开放日','主办行','协办行',
                    
                    // "开放期规则描述", '赎回后最少持有数量', '赎回/强制赎回天数','合同是否控制', '控制金额（元）', '经办人','理财产品登记编码','认购资金扣款速度（日）',
                    // '申购资金清算速度（日）','产品类型','信托登记编号','基金协会登记编号','其他类型编号',
                ]
            },
            // 招商平台扩展信息
            ExtensionSorting: {
                "产品基本信息": [
                    '项目简称', '项目编号', '产品名称', '产品代码', '招行全称', "招行简称", '产品主代码', '基金结算货币市场', 
                    // '线下购买是否有尾随', 
                    '网银展示方式', 
                    // '是否需二次/多次缴款', 
                    '产品收益呈现方式', 
                    // '预期收益率（年化%）',
                    // '可受理业务', 
                    // '特殊情况提示'
                ],
                "产品费率信息": [
                    '认购费率','申购费率','赎回费描述(兼容多段赎回费)','赎回费率多阶标志','多阶赎回费率详情','销售服务费率','固定管理费率','托管费率','业绩报酬类型','提取方法',
                    '固定日期','节假日调整方式','提成比例','提取第1个门槛值','提取第2个门槛值','提取第3个门槛值','业绩报酬费用描述','业绩报酬计提描述','强制赎回费率',

                    '是否存在固定费率',  '我行占分成比例（申购费）（%）', '我行占分成比例（认购费）（%）', '赎回费（不包含分段特殊情况）','赎回费描述（兼容多段赎回费）', '我行占分成比例（赎回费）（%）',
                    '其中我行应收固定管理费（%）', '是否存在浮动费率', '提取净值门槛', '业绩报酬提取方法-固定时点提取', '业绩报酬提取方法-赎回触发或到期（即强制赎回）触发',
                    '提取第1个产品净值（元）', '第1个提成比例（%）', '第1个银行提成比例（%）', '提取第2个产品净值（元）', '第2个提成比例（%）', '第2个银行提成比例（%）', '提取第3个产品净值（元）', '第3个提成比例（%）', '第3个银行提成比例（%）',
                    '提取第4个产品净值（元）', '第4个提成比例（%）', '第4个银行提成比例（%）', '提取第5个产品净值（元）', '第5个提成比例（%）', '第5个银行提成比例（%）',
                ],
                "资金清算账户信息": [
                    '托管账户账户名称', '托管账户账号', '托管账户开户网点', '托管账户大额支付号', '托管账户资金交收方式', '托管账户账户标志','托管账户开户日期','托管账户账户状态',
                    '认购账户账户名称', '认购账户账号', '认购账户开户网点', '认购账户大额支付号', '认购账户资金交收方式', '认购账户账户标志','认购账户开户日期','认购账户账户状态',
                    '申购账户账户名称', '申购账户账号','申购账户开户网点', '申购账户大额支付号','申购账户资金交收方式', '申购账户账户标志','申购账户开户日期','申购账户账户状态',
                    '分红款账户账户名称', '分红款账户账号', '分红款账户开户网点', '分红款账户大额支付号','分红款账户资金交收方式', '分红款账户账户标志','分红款账户开户日期','分红款账户账户状态',
                    '赎回款账户账户名称', '赎回款账户账号', '赎回款账户开户网点', '赎回款账户大额支付号','赎回款账户资金交收方式', '赎回款账户账户标志','赎回款账户开户日期','赎回款账户账户状态',
                    '认购退款账户账户名称','认购退款账户账号', '认购退款账户开户网点','认购退款账户大额支付号','认购退款账户资金交收方式', '认购退款账户账户标志','认购退款账户开户日期','认购退款账户账户状态'
                ],
                "联系人信息": [
                    '系统运行联系人姓名', '系统运行联系人电话', '系统运行联系人邮箱', '资金划付联系人姓名', '资金划付联系人电话', '资金划付联系人邮箱', '收入核对联系人姓名', '收入核对联系人电话',
                    '收入核对联系人邮箱', '项目经理姓名', '项目经理电话', '项目经理邮箱', '业务运行联系人姓名', '业务运行联系人电话', '业务运行联系人邮箱', '其他联系人姓名', '其他联系人电话',
                    '其他联系人邮箱', '信息披露联系人姓名', '信息披露联系人电话', '信息披露联系人邮箱', '净值联系人姓名', '净值联系人电话', '净值联系人邮箱', '信披联系人姓名', '信披联系人电话',
                    '信披联系人邮箱', '基金经理姓名', '基金经理电话', '基金经理邮箱', '开放期联系人姓名', '开放期联系人电话', '开放期联系人邮箱',
                    '月报联系人姓名', '月报联系人电话', '月报联系人邮箱','月报联系人机构全称'
                ],
                "净值监控信息": [
                    '参考日历(规则一)', '节假日调整方式(规则一)', 'T日生成频率(规则一)', 'T日确定方式(规则一)', 'T日固定日期(规则一)', '获取截止日（T+N天）(规则一)','是否自然日历(规则一)',
                    '参考日历(规则二)', '节假日调整方式(规则二)', 'T日生成频率(规则二)', 'T日确定方式(规则二)', 'T日固定日期(规则二)', '获取截止日（T+N天）(规则二)','是否自然日历(规则二)',
                    '参考日历(规则三)', '节假日调整方式(规则三)', 'T日生成频率(规则三)', 'T日确定方式(规则三)', 'T日固定日期(规则三)', '获取截止日（T+N天）(规则三)','是否自然日历(规则三)',
                    '参考日历(规则四)', '节假日调整方式(规则四)', 'T日生成频率(规则四)', 'T日确定方式(规则四)', 'T日固定日期(规则四)', '获取截止日（T+N天）(规则四)','是否自然日历(规则四)',
                    '参考日历(规则五)', '节假日调整方式(规则五)', 'T日生成频率(规则五)', 'T日确定方式(规则五)', 'T日固定日期(规则五)', '获取截止日（T+N天）(规则五)','是否自然日历(规则五)',

                    '净值联系人电话', '净值联系人邮箱', '信披联系人姓名', '信披联系人电话', '信披联系人邮箱', '基金经理姓名', '基金经理电话', '基金经理邮箱节',
                ],
            },
            // 开放期
            OpeningPeriod: {
                "产品基本信息": [
                    '项目简称', '项目编号', "产品代码", "产品名称", "开放期年份", "生成区间"
                ],
                "开放期计划信息": [
                    "文件唯一key值", "文件名", "文件类型", "文件大小（KB）", "生成时间"
                ]
            },

            date_fields: [],
            upgrade: [],
            filter_require: {},  //组装的 条件必填数据
            filter_req: false,  //条件判断是否开启必填

            fieldRules: {},  //所有字段的规则验证
            NeedDisable: [], // 需要禁用的表单
            emptylist: [], // 需要置空的f
            Needlsit: [],

            clearing: [], //资金清算账户信息组装内容
            clearingIf: [], //提交时的f级
            contact: [],
            contactIf: [],

            LimitType: [ // 资金清算账户信息必填组合
                {
                    basics: [
                        { title: "托管账户开户网点", serial: "1674_Ck9XJc5GQYurBaLN8FkWYd", Fgrade: "f72" },
                        { title: "托管账户账号", serial: "2627_iRa8CRhjEdpSCvP2MvnPJP", Fgrade: "f71" },
                        { title: "托管账户账户名称", serial: "8203_DZFg9bZXLMxtBorRrXXmLm", Fgrade: "f70" },
                        { title: "托管账户账户标志", serial: "1405_ctKZmcxDXq4Yan745uHPSk", Fgrade: "f188" },
                        { title: "托管账户开户日期", serial: "367_kjQY6BP563hzPNw9uV5k27", Fgrade: "f189" },
                        { title: "托管账户账户状态", serial: "1577_vRJBQpsotzDPQfAByNJmeQ", Fgrade: "f190" },
                    ],
                    jurisdiction: [
                        { title: "托管账户大额支付号", serial: "1405_X8gfsKzAMirAzuQFzpqhkh", Fgrade: "f73" },
                        { title: "托管账户资金交收方式", serial: "9484_sGiFd3CeDBgJC98YNiUXkk", Fgrade: "f74" }
                    ],
                },
                {
                    basics: [
                        { title: "认购账户账户名称", serial: "2304_PQTtqEkFbQ2kzfD2CNF5sX", Fgrade: "f75" },
                        { title: "认购账户账号", serial: "4237_LDdtZxLKN7pUxaWRRo5DyL", Fgrade: "f76" },
                        { title: "认购账户资金交收方式", serial: "7749_K6F4vwTqtrTuZWaNdfk5KX", Fgrade: "f79" },
                        { title: "认购账户开户网点", serial: "1232_r4pR9swHGTtZtTnNvXkfMo", Fgrade: "f77" },
                        { title: "认购账户账户标志", serial: "2280_WpQVxCoAbxcgeLzCFCrTs7", Fgrade: "f191" },
                        { title: "认购账户开户日期", serial: "5114_XiyaW7SXX3rVAY2xaxwNNQ", Fgrade: "f192" },
                        { title: "认购账户账户状态", serial: "8900_dHnsrdzdXyTqpQJN9Am4x4", Fgrade: "f193" },
                    ],
                    jurisdiction: [
                        { title: "认购账户大额支付号", serial: "4514_XCM5Ezb6f7cQNLFxRi4Qkk", Fgrade: "f78" }
                    ],
                },
                {
                    basics: [
                        { title: "申购账户账户名称", serial: "2221_dXaMkwQcfv4EeFdmuSGeH2", Fgrade: "f80" },
                        { title: "申购账户账号", serial: "6954_XSjPBzviCcBpJVFbXfZjqR", Fgrade: "f81" },
                        { title: "申购账户资金交收方式", serial: "265_BQxXj6aiLMxpKMbyVy9mqX", Fgrade: "f84" },
                        { title: "申购账户开户网点", serial: "1303_fRjaCqNhp5E7EueaXceJuZ", Fgrade: "f82" },
                        { title: "申购账户账户标志", serial: "3421_G5AHSoRvyj3wJQucqy8TPK", Fgrade: "f194" },
                        { title: "申购账户开户日期", serial: "9378_GDWG3KtxPUfiSr5KqxiyG3", Fgrade: "f195" },
                        { title: "申购账户账户状态", serial: "4733_YbQs7gzEmGUWoPWzcB7NxY", Fgrade: "f196" },
                    ],
                    jurisdiction: [
                        { title: "申购账户大额支付号", serial: "3757_dPwVGEwV5EKuashwYcFiZm", Fgrade: "f83" }
                    ],
                },
                { // 分红款账户
                    basics: [
                        { title: "分红款账户账户名称", serial: "8943_S98PSsfi8ZasRXdaRKsSqm", Fgrade: "f85" },
                        { title: "分红款账户账号", serial: "3855_9SpVe77aZRus8vjM7p85jg", Fgrade: "f86" },
                        { title: "分红款账户开户网点", serial: "6958_RBY3sSwMk4taoivYWBfdBM", Fgrade: "f87" },
                        { title: "分红款账户账户标志", serial: "714_YFduxZnrMYM3HBoNrx8zVc", Fgrade: "f197" },
                        { title: "分红款账户开户日期", serial: "6940_oYfEh5KGz6moKE4WwnJvd5", Fgrade: "f198" },
                        { title: "分红款账户账户状态", serial: "2199_oQqgJj3iHNkoiSoLXHmL6o", Fgrade: "f199" },
                    ],
                    jurisdiction: [
                        { title: "分红款账户大额支付号", serial: "9304_Yrv5PgWqmDqrp7hHcsxpw6", Fgrade: "f88" },
                        { title: "分红款账户资金交收方式", serial: "1550_bCGEmN8MvvQPgKNPVatvV6", Fgrade: "f89" },
                    ],
                },
                { // 赎回款账户
                    basics: [
                        { title: "赎回款账户账户名称", serial: "1542_HfaNr4RTxWy25Sripkse4N", Fgrade: "f90" },
                        { title: "赎回款账户账号", serial: "7551_GBw7AeGfHy8Td9mbZ54UE8", Fgrade: "f91" },
                        { title: "赎回款账户开户网点", serial: "1863_rNFHV78RojbbGEoJAyKR4j", Fgrade: "f92" },
                        { title: "赎回款账户账户标志", serial: "4304_mYz9GSsZcaUifqGX2mvzKD", Fgrade: "f200" },
                        { title: "赎回款账户开户日期", serial: "4756_xu7iVb5n23mqKBcUbD542c", Fgrade: "f201" },
                        { title: "赎回款账户账户状态", serial: "5114_Uv4QWrDwf2xeAQ376SStrM", Fgrade: "f202" },
                    ],
                    jurisdiction: [
                        { title: "赎回款账户大额支付号", serial: "996_6VJFN8JWWiw9e6SDyajuMS", Fgrade: "f93" },
                        { title: "赎回款账户资金交收方式", serial: "1033_QT6M5XWijWRnsQN8xoQCKL", Fgrade: "f94" },
                    ],
                },
                {
                    basics: [
                        { title: "认购退款账户开户网点", serial: "7719_pyBJoDoDEDcL6pVqgdRsdn", Fgrade: "f97" },
                        { title: "认购退款账户账号", serial: "2528_rJVAGsmtMzaVbXDdvWvJUn", Fgrade: "f96" },
                        { title: "认购退款账户账户名称", serial: "8646_xmAhmx5yUSqyeiZfhVDZ4j", Fgrade: "f95" },
                        { title: "认购退款账户账户标志", serial: "8601_zVA7jJuFZKPwmyTeriqzVH", Fgrade: "f203" },
                        { title: "认购退款账户开户日期", serial: "3651_58AJcBWbKb2WsCSmMxYkA5", Fgrade: "f204" },
                        { title: "认购退款账户账户状态", serial: "4987_Eh4UpeUoYPidwBRqCmkfyM", Fgrade: "f205" },
                    ],
                    jurisdiction: [
                        { title: "认购退款账户大额支付号", serial: "7072_o3xLKftKV8oUtMP3UkKgof", Fgrade: "f98" },
                        { title: "认购退款账户资金交收方式", serial: "1452_tJbsmzXzEUvVn3j6vHfT28", Fgrade: "f99" },
                    ],
                },
            ],
            restriction: [], // 输入必填状态

            ContactGroup: [ // 联系人信息必填组合
                {
                    basics: [
                        { title: "系统运行联系人姓名", serial: "3169_gquewZhQUoqU8Pgz9MBq85", Fgrade: "f100" },
                        { title: "系统运行联系人电话", serial: "5326_PAD4bpLeAFgPTrNxCwF9Kk", Fgrade: "f101" },
                        { title: "系统运行联系人邮箱", serial: "3780_iM9nRcU4oxjYYa9Gj9pYA4", Fgrade: "f102" },
                    ],
                },
                {
                    basics: [
                        { title: "资金划付联系人姓名", serial: "2502_48UPaDaSRxRNGQidfDpGwV", Fgrade: "f103" },
                        { title: "资金划付联系人电话", serial: "4642_2rfhJK2rHqfxdwNqorkwBF", Fgrade: "f104" },
                        { title: "资金划付联系人邮箱", serial: "6764_5RdyLtuacLLTMovmgSrJiY", Fgrade: "f105" },
                    ],
                },
                {
                    basics: [
                        { title: "收入核对联系人姓名", serial: "4340_CpvvAefkqRhwtV7yL6SFxA", Fgrade: "f106" },
                        { title: "收入核对联系人电话", serial: "4259_GigBabLVjSo5Zvu54Jf7y4", Fgrade: "f107" },
                        { title: "收入核对联系人邮箱", serial: "5418_R9JvZGJF4WueFkDp74u7CM", Fgrade: "f108" },
                    ],
                },
                {
                    basics: [
                        { title: "项目经理姓名", serial: "833_M2PvJoM3ZbbQF7K5yBWsm6", Fgrade: "f109" },
                        { title: "项目经理电话", serial: "5032_ioFbzTomdrcU9z5H7xx7Me", Fgrade: "f110" },
                        { title: "项目经理邮箱", serial: "313_CRq2VCqHu9KhrtHCTerN6k", Fgrade: "f111" },
                    ],
                },
                {
                    basics: [
                        { title: "业务运行联系人姓名", serial: "937_FHH9zDrh8KUyJrvCsrc5tL", Fgrade: "f112" },
                        { title: "业务运行联系人电话", serial: "1809_uYtgu9z85LMyCxCFjJYcN8", Fgrade: "f113" },
                        { title: "业务运行联系人邮箱", serial: "157_6A6RBgbUAHvX7jWRGquxP4", Fgrade: "f114" },
                    ],
                },
                {
                    basics: [
                        { title: "其他联系人姓名", serial: "430_wrw8B9LiJwYi2dNnjvxQ5m", Fgrade: "f115" },
                        { title: "其他联系人电话", serial: "1875_BpgvWPoTHmQqTL7ZRqE7AU", Fgrade: "f116" },
                        { title: "其他联系人邮箱", serial: "4744_gqVpYCtQ5UYfZzyso5gfxJ", Fgrade: "f117" },
                    ],
                },
                {
                    basics: [
                        { title: "信息披露联系人姓名", serial: "5820_CXAyRJGqdydVoGMGtWFyAA", Fgrade: "f118" },
                        { title: "信息披露联系人电话", serial: "6811_yS3J7VStMEj4KduAF7goRS", Fgrade: "f119" },
                        { title: "信息披露联系人邮箱", serial: "1755_pkKRvNXY3VyvKmTCrYRbE3", Fgrade: "f120" },
                    ],
                },
                {
                    basics: [
                        { title: "净值联系人姓名", serial: "1373_xBL8GQGZe2UkkpFkJ6NPCa", Fgrade: "f121" },
                        { title: "净值联系人电话", serial: "6624_odrngLtjbHGV6B6AVgdUza", Fgrade: "f122" },
                        { title: "净值联系人邮箱", serial: "5366_38Qjb4iKwzwYvF7DD9Q8wG", Fgrade: "f123" },
                    ],
                },
                {
                    basics: [
                        { title: "信披联系人姓名", serial: "4909_ibraSfnZMQ3oH6CxT6tmjN", Fgrade: "f124" },
                        { title: "信披联系人电话", serial: "3110_NmojWRfjDu7Ff4hYQCGpbf", Fgrade: "f125" },
                        { title: "信披联系人邮箱", serial: "2397_Tig4nsFApaNYXa3FAHLCvF", Fgrade: "f126" },
                    ],
                },
                {
                    basics: [
                        { title: "基金经理姓名", serial: "7863_oRHwLcqWaaskkSMABffaK4", Fgrade: "f127" },
                        { title: "基金经理电话", serial: "3284_Tw8XDeCtQSUfHyZuzwK27K", Fgrade: "f128" },
                        { title: "基金经理邮箱", serial: "9587_ryf5HKcHwmUWufM4NY4Aaj", Fgrade: "f129" },
                    ],
                },
                {
                    basics: [
                        { title: "月报联系人姓名", serial: "4786_MEQbUAhzEASi74GjN6KjKA", Fgrade: "f209" },
                        { title: "月报联系人电话", serial: "1384_QjBLaHthYugc7JeSg2uqcB", Fgrade: "f210" },
                        { title: "月报联系人邮箱", serial: "529_ho7Wusu8v4rnGv2jcfMJPj", Fgrade: "f211" },
                        { title: "月报联系人机构全称", serial: "4596_r4DnH8jvExWhUZwCXKyBsG", Fgrade: "f212" },
                    ],
                }
            ],
            linkmanList: [], // 联系人必填状态

            initialLsit: [], // 资金清算账户信息-有内容的回显
            contactList: [], // 联系人信息-有内容的回显

            quoteList: {}, // 引用项目列表
            newList: {}, // 引用的数据

            remindGoto: false,
            redemption: "",

            remind: false, // 校验提示
            issueList: [], // 提醒内容
            TCMPList: [],
            ThisSystem: [], 

            currency:"", // 基础表货币类型 

            ahead: ["f73", "f72", "f70", "f71", "f74", "f78", "f77", "f75", "f76", "f79", "f98", "f97", "f95", "f96", "f99",
            "f83", "f82", "f80", "f81", "f84", "f88", "f87", "f85", "f86", "f89", "f93", "f92", "f90", "f91", "f94", "f100", "f101",
            "f102", "f103", "f104", "f105", "f106", "f107", "f108", "f109", "f110", "f111", "f112", "f113", "f114", "f115", "f116",
            "f117", "f118", "f119", "f120", "f121", "f122", "f123", "f124", "f125", "f126", "f127", "f128", "f129",
            "f188", "f189", "f190", 
            "f191","f192","f193",
            "f194","f195","f196",
            "f197","f198","f199",
            "f200","f201","f202",
            "f203","f204","f205",
            "f209", "f210", "f211", "f212"],

            originalData:{}, // 原始数据


            multipleList:[
                {
                    name: "托管账户",
                    dataList: ["f73", "f72", "f70", "f71", "f74","f188", "f189", "f190"],
                },
                {
                    name: "认购账户",
                    dataList: ["f78", "f77", "f75", "f76", "f79","f191","f192","f193"],
                },
                {
                    name: "申购账户",
                    dataList: ["f83", "f82", "f80", "f81", "f84","f194","f195","f196"],
                },
                {
                    name: "分红款账户",
                    dataList: ["f88", "f87", "f85", "f86", "f89","f197","f198","f199"],
                },
                {
                    name: "赎回款账户",
                    dataList: ["f93", "f92", "f90", "f91", "f94","f200","f201","f202"],
                },
                {
                    name: "认购退款账户",
                    dataList: ["f95", "f96", "f97", "f98", "f99","f203","f204","f205"],
                },
            ],
    
            userList: [
                {
                    name: "系统运行",
                    dataList: ["f100", "f101", "f102"],
                },
                {
                    name: "资金划付",
                    dataList: ["f103", "f104", "f105"],
    
                },
                {
                    name: "收入核对",
                    dataList: ["f106", "f107", "f108"],
    
                },
                {
                    name: "项目经理",
                    dataList: ["f109", "f110", "f111"],
                },
                {
                    name: "业务运行",
                    dataList: ["f112", "f113", "f114"],
    
                },
                {
                    name: "其他",
                    dataList: ["f115", "f116", "f117"],
    
                },
                {
                    name: "信息披露",
                    dataList: ["f118", "f119", "f120"],
    
                },
                {
                    name: "净值",
                    dataList: ["f121", "f122", "f123"],
    
                },
                {
                    name: "信披",
                    dataList: ["f124", "f125", "f126"],
    
                },
                {
                    name: "基金经理",
                    dataList: ["f127", "f128", "f129"],
    
                },
                {
                    name: "月报",
                    dataList: ["f209", "f210", "f211", "f212"],
    
                },
            ],

            benchmark: false, // 业绩比较基准（区间高）（%）> 业绩比较基准（区间低）（%） 为 true
            benchmarkBig: false,

            needF:[], // 定制 需要禁用的  F几
        }
    };

    componentDidMount() {
        // console.log(this.props, "props")
        if (!this.props.data.iswork) {
            this.setState({
                choice: this.props.data.itemData.product_jc,
                choice_number: this.props.data.itemData.product_number,
            }, () => {
                this.echoEditList()
            })
        } else {
            this.setState({
                choice: this.props.data.present.f5,
                choice_number: this.props.data.present.f4,
            }, () => {
                this.echoEditList()
            })
        }
    }


    // 初始化数据请求
    echoEditList = () => {
        const { choice_number, table_name, orderingList, ExtensionSorting, OpeningPeriod, LimitType, ContactGroup } = this.state
        this.setState({ editloading: true })
        let params = {
            p_code: choice_number,
            data_type: table_name,
        }

        // 编辑初始化
        APIService.getDxjgProjInfo(params).then(res => {
            if (res.success) {
                console.log(res, "初始化请求")
                // res = table_name == 0 ? newData : zhaoshang;
                const date_fields = []; // 年月日
                const upgrade = [] // 带时分秒

                let titles = [], temp = {};
                let filter_require = {}, fieldRules = {}, NeedDisable = [], emptylist = [], Needlsit = [], restriction = [], linkmanList = [];
                let issueList = [], TCMPList = [], ThisSystem = [], needF = []
                let originalData = {} 

                if( table_name == 1 ) {
                    this.setState({ currency:res.currency })
                }
                /**
                 * @param {[type]} NeedDisable 初始化禁用
                */
                if (res.data) {
                    //组装条件必填
                    if (table_name == "0") {
                        Object.keys(orderingList).map((panel, i) => {
                            titles = orderingList[panel];
                            titles.map((title, index) => {
                                if (res.data[panel]) {
                                    if (res.data[panel][title]) {
                                        if (res.data[panel][title].dinput_type == "3") {
                                            date_fields.push(res.data[panel][title].field)
                                        }
                                        if (res.data[panel][title].dinput_type == "5") {
                                            upgrade.push(res.data[panel][title].field)
                                        }
                                        if (Object.keys(res.data[panel][title]['relevance_condition']).length > 0) {
                                            emptylist.push(res.data[panel][title])

                                            temp = res.data[panel][title].relevance_condition;
                                            if (!Object.keys(filter_require).includes(temp['field'])) {
                                                filter_require[temp['field']] = {};
                                            }
                                            filter_require[temp['field']][res.data[panel][title]['field_id']] = temp['value'][0]

                                            //这里判断是否需要组装禁用表单
                                            if (temp['dfield']) {
                                                let dname = temp['dfield']['dname']
                                                if (res.data[panel][dname].data === 'N' || res.data[panel][dname].data === 'A') {
                                                    NeedDisable.push(res.data[panel][title]['field_id'])
                                                }
                                            }

                                        }
                                        fieldRules[res.data[panel][title]['field_id']] = []

                                        if (res.data[panel][title]['reg'] && Object.keys(res.data[panel][title]['reg']).length > 0) {
                                            Object.keys(res.data[panel][title]['reg']).map(reg => {
                                                fieldRules[res.data[panel][title]['field_id']].push({
                                                    pattern: new RegExp(this.trim(reg, '/')),
                                                    message: res.data[panel][title]['reg'][reg]
                                                })
                                            })
                                        }
                                        if (res.data[panel][title].drequired) {
                                            fieldRules[res.data[panel][title]['field_id']].push({
                                                required: true,
                                                message: `${res.data[panel][title].name} 为必填项`
                                            })
                                        } else {
                                            fieldRules[res.data[panel][title]['field_id']].push({
                                                required: false,
                                                message: `${res.data[panel][title].name} 为必填项`
                                            })
                                        }

                                        // 上游数据空缺
                                        if (res.data[panel][title].edit_data == 0 && res.data[panel][title].data == "") {
                                            if (res.data[panel][title].data_origin == "TA") {
                                                issueList.push(res.data[panel][title].name)
                                            }
                                            if (res.data[panel][title].data_origin == "TCMP") {
                                                TCMPList.push(res.data[panel][title].name)
                                            }
                                            if (res.data[panel][title].data_origin == "机构服务平台（本系统）") {
                                                ThisSystem.push(res.data[panel][title].name)
                                            }
                                        }
                                    }
                                }
                            })
                        })
                    } else if (table_name == "1") {
                        Object.keys(ExtensionSorting).map((panel, i) => {
                            titles = ExtensionSorting[panel];
                            titles.map((title, index) => {
                                if (res.data[panel]) {
                                    if (res.data[panel][title]) {
                                        if (res.data[panel][title].dinput_type == "3") {
                                            date_fields.push(res.data[panel][title].field)
                                        }
                                        if (res.data[panel][title].dinput_type == "5") {
                                            upgrade.push(res.data[panel][title].field)
                                        }
                                        if (Object.keys(res.data[panel][title]['relevance_condition']).length > 0) {
                                            emptylist.push(res.data[panel][title])
                                            temp = res.data[panel][title].relevance_condition;
                                            if (!Object.keys(filter_require).includes(temp['field'])) {
                                                filter_require[temp['field']] = {};
                                            }
                                            filter_require[temp['field']][res.data[panel][title]['field_id']] = temp['value'][0]

                                            //这里判断是否需要组装禁用表单
                                            if (temp['dfield']) {
                                                let dname = temp['dfield']['dname']
                                                if (res.data[panel][dname]) {
                                                    if (res.data[panel][dname].data === 'N') {
                                                        NeedDisable.push(res.data[panel][title]['field_id'])
                                                    }
                                                    if (res.data[panel][dname].data) {
                                                        Needlsit.push(res.data[panel][title]['field_id'])
                                                    }
                                                }
                                            }
                                        }

                                        // Needlsit 初始化必填项 
                                        fieldRules[res.data[panel][title]['field_id']] = []

                                        if (res.data[panel][title]['reg'] && Object.keys(res.data[panel][title]['reg']).length > 0) {
                                            Object.keys(res.data[panel][title]['reg']).map(reg => {   
                                                fieldRules[res.data[panel][title]['field_id']].push({
                                                    pattern: new RegExp(this.trim(reg, '/')),
                                                    message: res.data[panel][title]['reg'][reg]
                                                })
                                            })
                                        } 
                                        if (panel == "资金清算账户信息") {
                                            LimitType.map((item, index) => {
                                                if (res.data[panel][title].field == item.jurisdiction[0].Fgrade) {
                                                    // 满足最高等级的条件-下级必填
                                                    if (res.data[panel][title].data) {
                                                        item.basics.map(i => {
                                                            if (!fieldRules[i.serial]) {
                                                                fieldRules[i.serial] = []
                                                            }
                                                            fieldRules[i.serial].push({
                                                                required: true,
                                                                message: `${i.title} 为必填项`
                                                            })
                                                            restriction.push(i.serial)
                                                        })
                                                    } else {
                                                        item.basics.map(i => {
                                                            if (res.data[panel][i.title]) {
                                                                if (!fieldRules[res.data[panel][i.title]['field_id']]) {
                                                                    fieldRules[res.data[panel][i.title]['field_id']] = []
                                                                }
                                                                if (res.data[panel][i.title].drequired) {
                                                                    fieldRules[res.data[panel][i.title]['field_id']].push({
                                                                        required: true,
                                                                        message: `${res.data[panel][i.title].name} 为必填项`
                                                                    })
                                                                } else {
                                                                    fieldRules[res.data[panel][i.title]['field_id']].push({
                                                                        required: false,
                                                                        message: `${res.data[panel][i.title].name} 为必填项`
                                                                    })
                                                                }
                                                            }
                                                        })
                                                    }

                                                    if (res.data[panel][title].drequired) {
                                                        fieldRules[res.data[panel][title]['field_id']].push({
                                                            required: true,
                                                            message: `${res.data[panel][title].name} 为必填项`
                                                        })
                                                    } else {
                                                        fieldRules[res.data[panel][title]['field_id']].push({
                                                            required: false,
                                                            message: `${res.data[panel][title].name} 为必填项`
                                                        })
                                                    }
                                                }
                                            })
                                        } else if (panel == "联系人信息") {
                                            if (res.data[panel][title].drequired) {
                                                fieldRules[res.data[panel][title]['field_id']].push({
                                                    required: true,
                                                    message: `${res.data[panel][title].name} 为必填项`
                                                })
                                            } else {
                                                fieldRules[res.data[panel][title]['field_id']].push({
                                                    required: false,
                                                    message: `${res.data[panel][title].name} 为必填项`
                                                })
                                            }

                                            ContactGroup.map(item => {
                                                let condition = false
                                                for (let i = 0; i < item.basics.length; i++) {
                                                    if (res.data[panel][title].name == item.basics[i].title) {
                                                        if (res.data[panel][title].data) {
                                                            condition = true
                                                            break
                                                        }
                                                    }
                                                }
                                                if (condition) {
                                                    item.basics.map(i => {
                                                        if (!linkmanList.includes(i.serial)) {
                                                            linkmanList.push(i.serial)
                                                        }
                                                    })
                                                }
                                            })
                                        } else {
                                            if (res.data[panel][title].drequired) {
                                                fieldRules[res.data[panel][title]['field_id']].push({
                                                    required: true,
                                                    message: `${res.data[panel][title].name} 为必填项`
                                                })
                                            } else {
                                                fieldRules[res.data[panel][title]['field_id']].push({
                                                    required: false,
                                                    message: `${res.data[panel][title].name} 为必填项`
                                                })
                                            }
                                        }

                                        // 上游数据空缺
                                        if (res.data[panel][title].edit_data == 0 && res.data[panel][title].data === "") {
                                            if (res.data[panel][title].data_origin == "TA") {
                                                issueList.push(res.data[panel][title].name)
                                            }
                                            if (res.data[panel][title].data_origin == "TCMP") {
                                                TCMPList.push(res.data[panel][title].name)
                                            }
                                            if (res.data[panel][title].data_origin == "机构服务平台（本系统）") {
                                                ThisSystem.push(res.data[panel][title].name)
                                            }
                                        }

                                        // 多阶赎回费率详情 根据 赎回费率多阶标志 的值 是否 为S 决定 是否禁用
                                        if(res.data[panel][title].field == 'f174' && res.data[panel][title].data == "S"){
                                            needF.push(...['f175'])
                                        }
                                    }
                                }
                            })
                        })
                    } else {
                        Object.keys(OpeningPeriod).map((panel, i) => {
                            titles = OpeningPeriod[panel];
                            titles.map((title, index) => {
                                if (res.data[panel]) {
                                    if (res.data[panel][title]) {
                                        if (res.data[panel][title].dinput_type == "3") {
                                            date_fields.push(res.data[panel][title].field)
                                        }
                                        if (res.data[panel][title].dinput_type == "5") {
                                            upgrade.push(res.data[panel][title].field)
                                        }
                                        if (Object.keys(res.data[panel][title]['relevance_condition']).length > 0) {
                                            emptylist.push(res.data[panel][title])

                                            temp = res.data[panel][title].relevance_condition;
                                            if (!Object.keys(filter_require).includes(temp['field'])) {
                                                filter_require[temp['field']] = {};
                                            }
                                            filter_require[temp['field']][res.data[panel][title]['field_id']] = temp['value'][0]

                                            //这里判断是否需要组装禁用表单
                                            if (temp['dfield']) {
                                                let dname = temp['dfield']['dname']
                                                if (res.data[panel][dname]) {
                                                    if (res.data[panel][dname].data === 'N') {
                                                        NeedDisable.push(res.data[panel][title]['field_id'])
                                                    }
                                                }
                                            }
                                        }

                                        fieldRules[res.data[panel][title]['field_id']] = []
                                        if (res.data[panel][title]['reg'] && Object.keys(res.data[panel][title]['reg']).length > 0) {
                                            Object.keys(res.data[panel][title]['reg']).map(reg => {
                                                fieldRules[res.data[panel][title]['field_id']].push({
                                                    pattern: new RegExp(this.trim(reg, '/')),
                                                    message: res.data[panel][title]['reg'][reg]
                                                })
                                            })
                                        }

                                        if (res.data[panel][title].drequired) {
                                            fieldRules[res.data[panel][title]['field_id']].push({
                                                required: true,
                                                message: `${res.data[panel][title].name} 为必填项`
                                            })
                                        } else {
                                            fieldRules[res.data[panel][title]['field_id']].push({
                                                required: false,
                                                message: `${res.data[panel][title].name} 为必填项`
                                            })
                                        }
                                    }
                                }
                            })
                        })
                    }

                    if(res.orignal_data){
                        Object.values(res.orignal_data).map((i, index) => {
                            Object.values(i).map((item, index) => {
                                // console.log(item.field)
                                if (date_fields.includes(item.field)) {
                                    originalData[item.field] = item.data ? moment(item.data, 'YYYY-MM-DD') : undefined;
                                } else if (upgrade.includes(item.field)) {
                                    originalData[item.field] = item.data ? moment(item.data, 'YYYY-MM-DD HH:mm:ss') : undefined;
                                } else {
                                    originalData[item.field] = item.data
                                }
                            })
                        })
                        message.success('成功载入草稿数据');
                    }    
                }
                // console.log(date_fields, "date_fields")

                let formlist = {}, currentlist = {}
                Object.values(res.data).map((i, index) => {
                    Object.values(i).map((item, index) => {
                        // console.log(item.field)
                        if (date_fields.includes(item.field)) {
                            formlist[item.field] = item.data ? moment(item.data, 'YYYY-MM-DD') : undefined;
                            currentlist[item.field] = item.data ? moment(item.data, 'YYYY-MM-DD') : undefined;
                        } else if (upgrade.includes(item.field)) {
                            formlist[item.field] = item.data ? moment(item.data, 'YYYY-MM-DD HH:mm:ss') : undefined;
                            currentlist[item.field] = item.data ? moment(item.data, 'YYYY-MM-DD HH:mm:ss') : undefined;
                        } else {
                            formlist[item.field] = item.data
                            currentlist[item.field] = item.data
                        }
                    })
                })

                if (table_name == "0") {
                    currentlist['f50'] = currentlist['f50'] ? currentlist['f50'] : 0.00;
                    currentlist['f51'] = currentlist['f51'] ? currentlist['f51'] : 0.00;
                    if(currentlist['f50'] < 0 || currentlist['f50'] == 0 || currentlist['f50'] == 0.00){
                        this.setState({
                            benchmarkBig: true,
                        })
                    }
                    if(currentlist['f49'] == ''){
                        needF.push(...['f50','f51'])
                        this.setState({
                            benchmarkBig: false,
                            benchmark: false,
                        })
                    }else if(currentlist['f49'] == 'A'){
                        needF.push(...['f51'])
                        this.setState({
                            benchmarkBig: currentlist['f50'] > 0 ? false : true,
                            benchmark: false,
                        })
                    }else if(currentlist['f49'] == 'B'){
                        this.setState({
                            benchmarkBig: currentlist['f50'] > 0 ? false : true,
                            benchmark: currentlist['f51'] > currentlist['f50'] > 0 ? false : true,
                        })
                    }
                }
            

                // console.log(NeedDisable, "NeedDisable")
                // console.log(Needlsit, "Needlsit")

                if (Needlsit){
                    Needlsit.map((item,index) => {
                        if (!(NeedDisable.includes(item))){
                            if (fieldRules[item]){
                                fieldRules[item].map(i => {
                                    i.required = true
                                    return
                                })
                            }
                        }
                    })
                }
               

                // console.log(fieldRules, "fieldRules")
                // console.log('filter_require', filter_require)
                this.initialize(res.data)

                // 存在上游缺失的数据 发出提示
                if (issueList.length || TCMPList.length || ThisSystem.length) {
                    this.setState({ remind: true })
                }

                console.log(originalData,"原始数据")

                this.setState({
                    formData: res.data, formlist , currentlist , date_fields: date_fields, upgrade: upgrade, editloading: false,
                    filter_require, fieldRules, NeedDisable, emptylist, Needlsit, restriction, linkmanList, redemption: formlist["f27"],
                    issueList, TCMPList, ThisSystem , originalData, needF
                })

            } else {
                message.error(res.error);
            }
        }).catch(err => {
            console.log('编辑基础信息', err);
        })
    }

    trim = (val, char, type) => {
        if (char) {
            if (type == 'left') {
                return val.replace(new RegExp('^\\' + char + '+', 'g'), '');
            } else if (type == 'right') {
                return val.replace(new RegExp('\\' + char + '+$', 'g'), '');
            }
            return val.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');
        }
        return val.replace(/^\s+|\s+$/g, '');
    };

    onClose = () => {
        this.setState({ visible: false })
    }

    // 提交编辑请求
    onFinish = (formData) => {
        const { formlist, choice_number, table_name, date_fields, upgrade, currency , ahead , originalData} = this.state
        this.setState({ SubmissionProcess: true })
        console.log(formlist, "formlist")
        console.log(formData, "formData")

        let values = {}
        let oldValues = {}
        let absentLits = []

        Object.keys(formData).map((item, index) => {
            if (date_fields.includes(item) && formData[item]) {
                values[item] = formData[item].format('YYYY-MM-DD');
            } else if (upgrade.includes(item) && formData[item]) {
                values[item] = formData[item].format('YYYY-MM-DD HH:mm:ss');
            } else {
                if(table_name == "1" && item == 'f175'){
                    formData[item].forEach(item => {
                        item.redFee = parseFloat(item.redFee).toFixed(2);
                    })
                }
                if(table_name == '0'){
                    if(item == 'f50' || item == 'f51'){
                        formData[item] = parseFloat(formData[item]).toFixed(2);
                    }
                }
                values[item] = formData[item];
            }
        })

        if (table_name == "1"){
            ahead.map(item => {
                if (!(Object.keys(values).includes(item))){
                    absentLits.push(item)
                }
            })
            absentLits.map(item => {
                values[item] = ""
            })
        }

        if(table_name == '0' && this.state.benchmark && values['f49'] == 'B' && values['f49'] !== ''){
            message.warning('业绩比较基准（区间高）需大于 业绩比较基准（区间低）！')
            this.setState({ SubmissionProcess: false })
            return false
        }

        if(table_name == '0' && this.state.benchmarkBig && values['f49'] !== ''){
            message.warning('业绩比较基准（区间低）需大于零！')
            this.setState({ SubmissionProcess: false })
            return false
        }

        if(table_name == '1'){
            let isAdopt;
            values['f175'].forEach(item => {
                if(item.require){
                    isAdopt = false;
                    message.error('多阶赎回费率详情范围最大值必须大于最小值！')
                    this.setState({ SubmissionProcess: false })
                }
            })
            if(isAdopt == false){
                return false
            }
        }
        
        if (Object.keys(originalData).length){
            Object.keys(originalData).map((item, index) => {
                if (date_fields.includes(item) && originalData[item]) {
                    oldValues[item] = originalData[item].format('YYYY-MM-DD');
                } else if (upgrade.includes(item) && originalData[item]) {
                    oldValues[item] = originalData[item].format('YYYY-MM-DD HH:mm:ss');
                } else {
                    oldValues[item] = originalData[item];
                }
            })
        }else {
            Object.keys(formlist).map((item, index) => {
                if (date_fields.includes(item) && formlist[item]) {
                    oldValues[item] = formlist[item].format('YYYY-MM-DD');
                } else if (upgrade.includes(item) && formlist[item]) {
                    oldValues[item] = formlist[item].format('YYYY-MM-DD HH:mm:ss');
                } else {
                    oldValues[item] = formlist[item];
                }
            })
        }
        // console.log(values, oldValues, "Values")
        let formString = JSON.stringify(oldValues)
        let stringData = JSON.stringify(values)

        // console.log("cache_old",formString)
        // console.log("cache_new",stringData)
        let flag = false;
        Object.keys(values).map((title) => {
            if (oldValues[title] !== values[title]) {
                flag = true;
            }
        })
        if (!flag) {
            this.setState({ SubmissionProcess: false })
            return message.warning('当前修改与上次无差异');
        }  else if (values.f164 == "N" && values.f51 == "N") {
            this.setState({ SubmissionProcess: false })
            return message.warning('注意：固定费率和浮动费率至少要有一个值为 “是”');
        } else if (currency == "CNY" && values.f6 == "Y" ){
            this.setState({ SubmissionProcess: false })
            return message.warning('注意：通用平台基础产品信息中币种为人民币，基金结算货币市场请填写现钞。');
        } else {
            let params = {
                p_code: choice_number,
                data_type: table_name,
                cache_old: formString,
                cache_new: stringData
            }

            return APIService.SaveDxjgProjInfo(params).then(res => {
                if (res.success) {
                    if (table_name == 0) {
                        message.success('提交成功');
                        this.setState({ SubmissionProcess: false, remindGoto: true })
                    } else {
                        this.setState({ SubmissionProcess: false })
                        this.props.data.event.closeDialog();
                        message.success('提交成功');
                    }
                } else {
                    this.setState({ SubmissionProcess: false })
                    message.error(res.error);
                }
            }).catch(err => {
                console.log('编辑基础信息', err);
            })
        }
    }
    onFinishFailed = (errorInfo) => {
        let errorList = errorInfo.errorFields

        if (errorList.length > 5) {
            errorList.length = 5
            message.warning(
                `请注意检查：
                    ${errorList.map((item, index) => {
                    return item.errors[0] + `${errorList.length == index + 1 ? "....." : ""}`
                })}
                `
            );
        } else {
            message.warning(
                `请注意检查：
                    ${errorList.map((item, index) => {
                    return item.errors[0]
                })}
                `
            );
        }
    }

    handleChange = (value) => {
        const { formData } = this.state
        const clearing = [], clearingIf = []
        let dividends = ["f88", "f87", "f85", "f86", "f89","f197","f198","f199"] // 分红
        let collocation = ["f73", "f72", "f70", "f71", "f74","f188", "f189", "f190"] // 托管
        let subscribe = ["f83", "f82", "f80", "f81", "f84","f194","f195","f196"] // 申购
        let subscription = ["f78", "f77", "f75", "f76", "f79","f191","f192","f193"] // 认购
        let redemption = ["f93", "f92", "f90", "f91", "f94","f200","f201","f202"] // 赎回
        let reimburse = ["f98", "f97", "f95", "f96", "f99","f203","f204","f205"] // 认购退款账户

        if (value.length) {
            value.map(item => {
                if (item == "认购账户") {
                    Object.keys(formData["资金清算账户信息"]).map(title => {
                        let insertion = formData["资金清算账户信息"][title]
                        subscription.map(i => {
                            clearingIf.push(i)
                            if (i == insertion.field) {
                                clearing.push(title)
                            }
                        })
                    })
                } else if (item == "申购账户") {
                    Object.keys(formData["资金清算账户信息"]).map(title => {
                        let insertion = formData["资金清算账户信息"][title]
                        subscribe.map(i => {
                            clearingIf.push(i)
                            if (i == insertion.field) {
                                clearing.push(title)
                            }
                        })
                    })
                }
                else if (item == "托管账户") {
                    Object.keys(formData["资金清算账户信息"]).map(title => {
                        let insertion = formData["资金清算账户信息"][title]
                        collocation.map(i => {
                            clearingIf.push(i)
                            if (i == insertion.field) {
                                clearing.push(title)
                            }
                        })
                    })
                }
                else if (item == "分红款账户") {
                    Object.keys(formData["资金清算账户信息"]).map(title => {
                        let insertion = formData["资金清算账户信息"][title]
                        dividends.map(i => {
                            clearingIf.push(i)
                            if (i == insertion.field) {
                                clearing.push(title)
                            }
                        })
                    })
                } else if (item == "认购退款账户") {
                    Object.keys(formData["资金清算账户信息"]).map(title => {
                        let insertion = formData["资金清算账户信息"][title]
                        reimburse.map(i => {
                            clearingIf.push(i)
                            if (i == insertion.field) {
                                clearing.push(title)
                            }
                        })
                    })
                } else if (item == "赎回款账户") {
                    Object.keys(formData["资金清算账户信息"]).map(title => {
                        let insertion = formData["资金清算账户信息"][title]
                        redemption.map(i => {
                            clearingIf.push(i)
                            if (i == insertion.field) {
                                clearing.push(title)
                            }
                        })
                    })
                }
            })
        }
        // console.log(clearing,"clearing")

        this.setState({ clearing, clearingIf, initialLsit: value })
    }

    // 初始化折叠
    initialize = (present, extra) => {
        let { initialLsit, clearingIf, clearing , userList , multipleList} = this.state
        const { table_name } = this.state
        
        let contactList = [], contactIf = [], contact = []

        if (!extra) {
            initialLsit = [],
                clearingIf = [],
                clearing = []
        }

        // 为扩展表的时候
        if (table_name == "1") {
            // 引用其他项目数据时 资金清算账户信息 不处理
            if (!extra) {
                multipleList.map((item, index) => {
                    item.dataList.map(i => {
                        Object.keys(present["资金清算账户信息"]).map(title => {
                            let insertion = present["资金清算账户信息"][title]
                            if (insertion.field == i && insertion.data && !initialLsit.includes(item.name)) {
                                initialLsit.push(item.name)
                                item.dataList.map(z => {
                                    clearingIf.push(z)
                                })
                            }
                            clearingIf.map(fstep => {
                                if (insertion.field == fstep && !clearing.includes(title)) {
                                    clearing.push(title)
                                }
                            })
                        })
                    })
                })
            }

            userList.map((item, index) => {
                item.dataList.map(i => {
                    Object.keys(present["联系人信息"]).map(title => {
                        let insertion = present["联系人信息"][title]
                        if (insertion.field == i && insertion.data && !contactList.includes(item.name)) {
                            contactList.push(item.name)
                            item.dataList.map(z => {
                                contactIf.push(z)
                            })
                        }
                        contactIf.map(fstep => {
                            if (insertion.field == fstep && !contact.includes(title)) {
                                contact.push(title)
                            }
                        })
                    })
                })
            })
        }

        this.setState({ initialLsit, clearingIf, clearing, contactList, contactIf, contact })
    }

    linkman = (value) => {
        const { formData } = this.state
        const contact = [], contactIf = []

        let business = ["f112", "f113", "f114"] // 业务运行
        let announce = ["f118", "f119", "f120"] // 信息披露
        let letterOver = ["f124", "f125", "f126"] // 信披
        let rests = ["f115", "f116", "f117"] // 其他
        let netWorth = ["f121", "f122", "f123"] // 净值
        let portfolio = ["f127", "f128", "f129"] // 经理 
        let verification = ["f106", "f107", "f108"]  // 核对
        let system = ["f100", "f101", "f102"] // 系统 
        let capital = ["f103", "f104", "f105"] // 资金
        let project = ["f109", "f110", "f111"] // 项目
        let MonthlyReport = ["f209", "f210", "f211", "f212"] // 月报

        if (value.length) {
            value.map(item => {
                if (item == "系统运行") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        system.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "资金划付") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        capital.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "收入核对") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        verification.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "项目经理") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        project.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "业务运行") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        business.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "其他") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        rests.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "信息披露") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        announce.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "净值") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        netWorth.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "信披") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        letterOver.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "基金经理") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        portfolio.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                } else if (item == "月报") {
                    Object.keys(formData["联系人信息"]).map(title => {
                        let insertion = formData["联系人信息"][title]
                        MonthlyReport.map(i => {
                            contactIf.push(i)
                            if (i == insertion.field) {
                                contact.push(title)
                            }
                        })
                    })
                }
            })
        }

        this.setState({ contact, contactIf, contactList: value })
    }

    // 切换表格名称
    SwitchTableName = (value, tba, skip) => {
        if (tba) {
            const { formlist } = this.state

            let newData = JSON.stringify(formlist) // 初始的form
            let oldData = JSON.stringify(this.formRef.current.getFieldsValue(true)) // 修改后的form

            if (newData === oldData || skip) { // 无差异时
                this.setState({ remindGoto: false, editloading: true, table_name: value, name_platform: tba }, () => {
                    this.echoEditList()
                })
            } else {
                this.setState({ admonish: true, valueOfthe: value, platform: tba });
            }
        } else {
            const { formlist } = this.state

            let newData = JSON.stringify(formlist) // 初始的form
            let oldData = JSON.stringify(this.formRef.current.getFieldsValue(true)) // 修改后的form

            if (newData === oldData) { // 无差异时
                this.setState({ editloading: true, table_name: value }, () => {
                    this.echoEditList()
                })
            } else {
                this.setState({ admonish: true, valueOfthe: value });
            }
        }
    }

    // 联系输入框监控
    inputState = (value, present) => {
        const { fieldRules, linkmanList, ContactGroup, currentlist } = this.state
        const { getFieldsValue } = this.formRef.current;
        let currentData = getFieldsValue(true)

        ContactGroup.map((item, index) => {
            item.basics.map((z) => {
                if (z.title == present) {
                    ContactGroup[index].basics.map(i => {
                        if (!linkmanList.includes(i.serial)) {
                            linkmanList.push(i.serial)
                        }
                        fieldRules[i.serial].map(item => {
                            if (item.required == false) {
                                item.required = true
                            }
                        })
                    })
                }
            })

            let condition = false
            console.log(item.basics, "item.basics")
            // 同级一项里有值-全部必填
            for (var i = 0; i < item.basics.length; i++) {
                if (currentData[item.basics[i].Fgrade]) {
                    condition = true
                    break;
                }
            }
            // 同级都为空-全部取消必填
            if (!condition) {
                item.basics.map(i => {
                    linkmanList.map((control, c) => {
                        if (control === i.serial) {
                            linkmanList.splice(c, 1);
                        }
                    })
                    fieldRules[i.serial].map(item => {
                        if (item.required == true) {
                            item.required = false
                        }
                    })
                    currentlist[i.Fgrade] = ""
                    this.formRef.current.resetFields([i.Fgrade]);
                })
            }
        })

        this.setState({ fieldRules, linkmanList, currentlist })
    }

    // 监听输入改变对应必填状态
    changeState = (value, present) => {
        const { fieldRules, restriction, LimitType, currentlist } = this.state
        const { getFieldsValue } = this.formRef.current;
        let currentData = getFieldsValue(true)

        // present:表单名称  currentData：表单内容
        LimitType.map((item, index) => {

            let condition_top = false
            for (let i = 0; i < item.jurisdiction.length; i++) {
                if (present == item.jurisdiction[i].title) {
                    if (value) {
                        condition_top = true
                        break
                    }
                }
            }

            // 满足最高等级的条件
            if (condition_top) {
                // 该下级必填
                LimitType[index].basics.map(i => {
                    Object.keys(fieldRules).map(each => {
                        // 查找对应下标-修改必填状态
                        if (i.serial == each && !restriction.includes(each)) {
                            restriction.push(each)
                            fieldRules[each].map(item => {
                                if (item.required == false) {
                                    item.required = true
                                }
                            })
                        }
                    })
                })
            }
            if (!condition_top) {
                let condition = false
                // 下级一项里有值-全部必填
                for (var i = 0; i < item.basics.length; i++) {
                    if (currentData[item.basics[i].Fgrade]) {
                        condition = true
                        break;
                    }
                }
                // 下级都为空-全部取消必填
                if (!condition) {
                    item.basics.map(i => {
                        restriction.map((control, c) => {
                            if (control === i.serial) {
                                restriction.splice(c, 1);
                            }
                        })
                        fieldRules[i.serial].map(item => {
                            if (item.required == true) {
                                item.required = false
                            }
                        })

                        currentlist[i.Fgrade] = ""
                        this.formRef.current.resetFields([i.Fgrade]);
                    })
                }
            }

            // 下级的条件
            item.basics.map(paginal => {
                if (paginal.title == present && value !== "") {
                    // 该同级必填
                    LimitType[index].basics.map(i => {
                        Object.keys(fieldRules).map(each => {
                            // 查找对应下标-修改必填状态
                            if (i.serial == each && !restriction.includes(each)) {
                                restriction.push(each)
                                fieldRules[each].map(item => {
                                    if (item.required == false) {
                                        item.required = true
                                    }
                                })
                            }
                        })
                    })
                }
                // 输入的内容和字典匹配
                if (paginal.title == present && !value) {
                    // 如果最高等级的条件没填-检验下级
                    if (!currentData[LimitType[index].jurisdiction[0].Fgrade]) {
                        let condition = false
                        // 下级一项里有值-全部必填
                        for (var i = 0; i < item.basics.length; i++) {
                            if (currentData[item.basics[i].Fgrade]) {
                                condition = true
                                break;
                            }
                        }
                        // 下级都为空-全部取消必填
                        if (!condition) {
                            item.basics.map(i => {
                                restriction.map((control, c) => {
                                    if (control === i.serial) {
                                        restriction.splice(c, 1);
                                    }
                                })
                                fieldRules[i.serial].map(item => {
                                    if (item.required == true) {
                                        item.required = false
                                    }
                                })
                                currentlist[i.Fgrade] = ""
                                this.formRef.current.resetFields([i.Fgrade]);
                            })
                        }
                    }
                }
            })
        })

        this.setState({ fieldRules, restriction, currentlist })
    }

    submit = () => {
        this.formRef.current.submit()
    }

    agreeGo = () => {
        this.SwitchTableName("1", "招商平台", 1)
    }

    cancelit = () => {
        this.setState({ remindGoto: false })
        this.props.data.event.closeDialog();
    }

    // 打开引用界面
    showModal = () => {
        const { table_name } = this.state

        let params = {
            type_copy: 1,
            dxjg_copy: table_name ? "招商平台" : "通用平台"
        }

        APIService.getUrlData('/citic/project_list/', params).then(res => {
            if (res.success) {
                this.setState({ quoteList: res.data, isModalVisible: true })
            } else {
                message.error(res.error)
            }
        }).catch(err => {
            console.log('获取引入项目列表', err)
        })
    };

    handleOk = () => {
        const { BoxType, table_name } = this.state
        let params = {
            p_code: BoxType,
            data_type: table_name,
        }

        if (!BoxType) {
            message.warning("请选择需要引用的项目");
        } else {
            APIService.getDxjgProjInfo(params).then(res => {
                if (res.success) {
                    let newList = {}
                    let dispose = []
                    if (table_name == 0) {
                        dispose = ["f9", "f10", "f11", "f12"]
                    }

                    // 扩展表中资金清算账户信息 不引用
                    Object.keys(res.data).map((item, index) => {
                        if (item !== "资金清算账户信息") {
                            console.log(item, "item")
                            Object.keys(res.data[item]).map(i => {
                                if (dispose.includes(res.data[item][i].field)) {
                                    newList[res.data[item][i].field] = res.data[item][i].data ? moment(res.data[item][i].data, 'YYYY-MM-DD HH:mm:ss') : undefined
                                } else {
                                    newList[res.data[item][i].field] = res.data[item][i].data
                                }
                            })
                        }
                    })
                    this.setState({ newList: newList, isModalVisible: false, SubmissionProcess: true });
                    // 过滤不复制的f几
                    let abandoned = []
                    if (table_name == 0) {
                        abandoned = ["f3", "f4", "f5", "f9", "f10", "f11", "f12", "f14", "f15", "f16", "f19", "f20", "f21", 
                        "f32", "f38", "f39","f22", "f23", "f24", "f25", "f26"]
                    } else {
                        abandoned = ["f169", "f168", "f170", "f171"]
                    }

                    if (table_name == 1) {
                        this.initialize(res.data, 1)
                    }

                    // 增强用户体验
                    setTimeout(() => {
                        let tempForm = {}
                        Object.keys(newList).map(item => {
                            if (!abandoned.includes(item)) {
                                // console.log(item,newList[item],"newList[item]")
                                tempForm[item] = newList[item]
                            }
                        })
                        this.formRef.current.setFieldsValue(tempForm)
                        this.setState({ SubmissionProcess: false });
                    }, 2000);
                } else {
                    message.error(res.error)
                }
            }).catch(err => {
                console.log('获取引入项目列表', err)
            })
        }
    };

    handleCancel = () => {
        this.setState({ isModalVisible: false });
    };

    // 提醒确定
    forgetIt = () => {
        const { valueOfthe, platform } = this.state
        this.setState({ table_name: valueOfthe, name_platform: platform, editloading: true, admonish: false }, () => {
            this.echoEditList()
        })
    }
    // 提醒取消
    abrogate = () => {
        this.setState({ admonish: false, editloading: false });
    }

    changeReq = (field, filter) => {
        // console.log('changeReq', field, filter)
        const { getFieldValue } = this.formRef.current;
        let { fieldRules, emptylist, NeedDisable, currentlist, Needlsit } = this.state;
        // console.log("emptylist", emptylist)
        let value = getFieldValue(field);
        Object.keys(filter).map(effct => {
            let flag = false;
            switch (filter[effct]['k']) {
                case 'eq':
                    flag = value === filter[effct]['v'];
                    break;
                case 'gt':
                    flag = value === filter[effct]['v'];
                    break;
            }
            console.log('flag', flag, fieldRules[effct])
            if (!flag) {
                if (!Needlsit.includes(effct)) {
                    Needlsit.push(effct)
                }

                NeedDisable.push(effct)

                emptylist.map((item) => {
                    if (item.field_id == effct) {
                        currentlist[item.field] = ""
                        this.formRef.current.resetFields([item.field]);
                    }
                })
            } else {
                if (!Needlsit.includes(effct)) {
                    Needlsit.push(effct)
                }
                // 删除原数值里的值
                NeedDisable.map((item, index) => {
                    if (item == effct) {
                        NeedDisable.splice(index, 1); // 从下标 i 开始, 删除 1 个元素
                    }
                })
            }

            if (fieldRules[effct]) {
                fieldRules[effct].map((rule, index) => {
                    // console.log(rule, "rule")
                    // console.log(Object.keys(rule))
                    if (!Object.keys(rule).includes('required') && fieldRules[effct].length < 2) {
                        fieldRules[effct].push(
                            {
                                required: flag,
                                message: '此项为必填项！'
                            }
                        )
                        return
                    } else {
                        rule.required = flag
                        return
                    }
                })
            } else {
                fieldRules[effct] = [
                    {
                        required: flag,
                        message: '此项为必填项！'
                    }
                ]
            }
        })

        console.log("NeedDisable", NeedDisable)
        console.log('fieldRules', fieldRules,)
        this.setState((prev, props) => {
            return { fieldRules, NeedDisable, currentlist }
        })

    }

    // 保存草稿
    manuscript = () => {
        const { formlist , date_fields , upgrade  ,table_name , choice_number , contactList , initialLsit , userList , multipleList} = this.state
        const { getFieldsValue } = this.formRef.current;
        let currentData = getFieldsValue(true)
        this.setState({ SubmissionProcess: true })
        let values = {} , oldValues = {}

        console.log(contactList , initialLsit)

        Object.keys(currentData).map((item, index) => {
            if (date_fields.includes(item) && currentData[item]) {
                values[item] = currentData[item].format('YYYY-MM-DD');
            } else if (upgrade.includes(item) && currentData[item]) {
                values[item] = currentData[item].format('YYYY-MM-DD HH:mm:ss');
            } else {
                values[item] = currentData[item];
            }
        })

        let absentLits = []

        if (table_name == "1"){
            userList.map((item,index) => {
                if (!(contactList.includes(item.name))){
                    console.log(item,index)
                    userList[index].dataList.map(i => {
                        absentLits.push(i)
                    })
                }
            })
    
            multipleList.map((item,index) => {
                if (!(initialLsit.includes(item.name))){
                    console.log(item,index)
                    multipleList[index].dataList.map(i => {
                        absentLits.push(i)
                    })
                }
            })

            absentLits.map(item => {
                values[item] = ""
            })
        }

        Object.keys(formlist).map((item, index) => {
            if (date_fields.includes(item) && formlist[item]) {
                oldValues[item] = formlist[item].format('YYYY-MM-DD');
            } else if (upgrade.includes(item) && formlist[item]) {
                oldValues[item] = formlist[item].format('YYYY-MM-DD HH:mm:ss');
            } else {
                oldValues[item] = formlist[item];
            }
        })

        console.log(oldValues,values)

        let flag = false;
        Object.keys(values).map((title) => {
            if (oldValues[title] !== values[title]) {
                flag = true;
            }
        })
        if (!flag) {
            this.setState({ SubmissionProcess: false })
            return message.warning('保存失败:当前保存草稿内容与当前内容无差异');
        }else {
            let params = {
                data_type:table_name,
                p_code: choice_number,
                draft_data:JSON.stringify(values)
            }
            APIService.saveDxjgProjDraftInfo(params).then(res => {
                if (res.success) {
                    this.setState({ SubmissionProcess: false })
                    message.success('成功保存草稿');
                } else {
                    this.setState({ SubmissionProcess: false })
                    message.error(res.error)
                }
            }).catch(err => {
                console.log('获取引入项目列表', err)
            })

        }
    }

    onFieldsChange = (changedFields, allFields) => {
        const { getFieldsValue } = this.formRef.current;
        let currentData = getFieldsValue(true)
        // console.log(changedFields,'changedFields');
        if(this.state.table_name == 1 && changedFields[0].name[0] == 'f174'){
            let arr = [...this.state.needF]
            if(changedFields[0].value == "S"){
                if(this.state.needF.indexOf('f175') == -1){ arr.push('f175') }
                this.formRef.current.setFieldsValue({'f175':[]})
            }else{
                if(this.state.needF.indexOf('f175') >= 0){ arr.splice(this.state.needF.indexOf('f175'),1) }
            }
            this.setState({
                needF: arr,
            })
        }
        
        if(changedFields[0].name[0] == 'f175'){
            let undData = JSON.parse(JSON.stringify(currentData['f175']));
            if(changedFields[0].name[2] == 'max'){
                // console.log(undData,'undData--if');
                if(undData[changedFields[0].name[1] + 1]){
                    undData[changedFields[0].name[1] + 1].min = changedFields[0].value;
                }
                if(changedFields[0].value <= undData[changedFields[0].name[1]].min){
                    undData[changedFields[0].name[1]].require = true;
                }else{
                    delete undData[changedFields[0].name[1]].require;
                }
            }else {
                if(undData.length > 0){
                    if(changedFields[0].name[2] == 'unit' || changedFields[0].name[2] == 'redFee'){
                        return
                    }else{
                        undData[undData.length - 1] =  { max: '',  min: 0, redFee: 0, unit: "" };
                        if(undData[undData.length - 2]){
                            undData[undData.length - 1].min = undData[undData.length - 2].max;
                        }
                    }
                }else{
                    if(changedFields[0].length > 0){
                        undData[0] =  { max: '',  min: 0, redFee: 0, unit: "" };
                    }
                }
                // console.log(undData,'undData--else');
            }
            this.formRef.current.setFieldsValue({'f175':undData});
        }

        if(this.state.table_name == 0 && changedFields[0].name[0] == 'f51' && currentData['f49'] == 'B'){
            this.setState({
                benchmark: currentData['f51'] > currentData['f50'] ? false : true,
            })
        }

        if(this.state.table_name == 0 && changedFields[0].name[0] == 'f50' && currentData['f49'] == 'B'){
            this.setState({
                benchmark: currentData['f51'] > currentData['f50'] ? false : true,
            })
        }

        // f51 --- 业绩比较基准（区间高）
        // f50 --- 业绩比较基准（区间低）
        // 需要禁用的 把F添加进 needF
        if(this.state.table_name == 0 && changedFields[0].name[0] == 'f49'){
            let arr = [...this.state.needF]
            if(currentData['f49'] == ''){
                if(this.state.needF.indexOf('f50') == -1){ arr.push('f50') }
                if(this.state.needF.indexOf('f51') == -1){ arr.push('f51') }
                this.setState({ 
                    benchmark: false, 
                    benchmarkBig: false,
                },()=>{
                    this.formRef.current.setFieldsValue({'f50': '0.00','f51':'0.00'});
                })
            }else if(currentData['f49'] == 'A'){
                if(this.state.needF.indexOf('f50') >= 0){ arr.splice(this.state.needF.indexOf('f50'),1) }
                if(this.state.needF.indexOf('f51') == -1){ arr.push('f51') }
                this.setState({ 
                    benchmark:false,
                    benchmarkBig: currentData['f50'] > 0 ? false : true,
                })
                this.formRef.current.setFieldsValue({'f51':0.00});
            }else if(currentData['f49'] == 'B') {
                if(this.state.needF.indexOf('f50') >= 0){ arr.splice(this.state.needF.indexOf('f50'),1) }
                if(this.state.needF.indexOf('f51') >= 0){ arr.splice(this.state.needF.indexOf('f51'),1) }
                this.setState({ 
                    benchmark:true, 
                    benchmarkBig: currentData['f50'] > 0 ? false : true,
                 })
            }
            this.setState({ 
                needF: arr,
             })
        }
        if(this.state.table_name == 0 && changedFields[0].name[0] == 'f50'){
            this.setState({
                benchmarkBig: currentData['f50'] > 0 ? false : true,
            })
        }

    }

    render() {
        let { approveShow, info, isModalVisible, formData, listItems, project_typeL, editloading, fieldRules, quoteList,
            admonish, SubmissionProcess, editable, table_name, orderingList, ExtensionSorting, OpeningPeriod, remindGoto,
            filter_require, NeedDisable, Needlsit, clearing, contact, restriction, linkmanList, initialLsit, contactList,
            issueList, TCMPList, ThisSystem, benchmark, benchmarkBig, needF
        } = this.state;

        console.log("contact",contact)

        // console.log(TCMPList,"TCMPList")
        // console.log(formData, "formData")
        // console.log(NeedDisable, "NeedDisable")
        // console.log(restriction, "restriction")
        // console.log(linkmanList, "linkmanList")
        // console.log(this.state.formlist,"formlist")
        // console.log(this.state.currentlist)
        // console.log(this.state.oldContent,"oldContent")
        // console.log("currency", this.state.currency)

        let sort_data = table_name == "1" ? ExtensionSorting : (table_name == "3" ? OpeningPeriod : orderingList);
        const userHost = [
            { name: "扩展产品信息", subscript: "1" },
            // {name:"信披报告信息",subscript:"2"} , 
            // {name: "开放期计划信息", subscript: "3"},
        ]

        Object.keys(info).map(item => {
            if (info[item] == '' || info[item] == null || info[item] == undefined) {
                info[item] = '--'
            }
        })
        return (
            <ConfigProvider locale={zhCN}>
                <div id='produtpages'>
                    <Spin size="large" spinning={SubmissionProcess}>
                        <div className='produtpage-header'>
                            <Row>
                                <Col span={21}>
                                    <div>代销机构数据管理</div>
                                </Col>
                                <Col style={{ marginLeft: '15px' }} onClick={() => this.manuscript()}>
                                    <Button type='primary'>保存草稿</Button>
                                </Col>
                                <Col style={{ marginLeft: '10px' }}>
                                    <Button type='primary' onClick={() => this.submit()}>提交</Button>
                                </Col>
                                {/* {
                                    !editable && <Col style={{ marginLeft: '44px' }}>
                                        <Button type='primary' onClick={() => this.submit()}>提交</Button>
                                    </Col>
                                }
                                {
                                    approveShow &&
                                    <Col style={{ marginLeft: '44px' }}>
                                        <Space>
                                            <Button type='primary'>审批</Button>
                                            <Button type='primary'>驳回</Button>
                                        </Space>
                                    </Col>
                                } */}
                            </Row>
                        </div>

                        <div style={{ padding: "10px" }}>
                            <Skeleton active loading={editloading}>
                                <div className='produtpage-min'>
                                    <div className='produtpage-left'>
                                        <div className='produtpage-left-content'>
                                            <Anchor offsetTop={18} getContainer={() => document.getElementsByClassName("produtpage-min")[0]}>
                                                {
                                                    Object.keys(sort_data).map((item, index) => { return <Link key={index} href={`#${index}`} title={item} /> })
                                                }
                                            </Anchor>
                                        </div>
                                    </div>
                                    <div className='produtpage-center'>
                                        <div id='information-interval'>
                                            <Space>
                                                <Col className="Project_Information">
                                                    <div className="filtrate" >
                                                        <span className="triangle"></span>
                                                        <span className="monicker">项目</span>
                                                        <Select
                                                            disabled
                                                            // disabled={editable ? !isEdit : isEdit}
                                                            value={this.state.project_typeL}
                                                            style={{ width: 113, height: 34 }}
                                                            onChange={(value, option) => {
                                                                this.setState({ project_typeL: value })
                                                            }}
                                                        >
                                                            <Select.Option value="名称">名称</Select.Option>
                                                            {/* <Select.Option value="编号">编号</Select.Option> */}
                                                        </Select>
                                                        <Select
                                                            showSearch
                                                            disabled
                                                            // disabled={editable ? !isEdit : isEdit}
                                                            value={this.state.choice}
                                                            style={{ width: 400, height: 34, marginLeft: 6 }}
                                                            optionFilterProp="children"
                                                            onChange={(value, option) => {
                                                                this.setState({ choice: value })
                                                            }}
                                                        >
                                                            {
                                                                listItems.length > 0 && listItems.map((item, index) => {
                                                                    if (project_typeL == "名称") {
                                                                        return <Select.Option key={index} value={item.id}>{item.name}</Select.Option>
                                                                    } else {
                                                                        return <Select.Option key={index} value={item.id}>{item.project_id}</Select.Option>
                                                                    }
                                                                })
                                                            }
                                                        </Select>
                                                        <span className="monicker" style={{ marginLeft: '10px' }}>平台名称</span>
                                                        <Select
                                                            value={this.state.name_platform}
                                                            style={{ width: 145, height: 34 }}
                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                            onChange={(value, option) => {
                                                                if (value == "通用平台") {
                                                                    this.SwitchTableName("0", value)
                                                                } else {
                                                                    this.SwitchTableName("1", value)
                                                                }
                                                            }}
                                                        >
                                                            <Select.Option value="通用平台">通用平台</Select.Option>
                                                            <Select.Option value="招商平台">招商平台</Select.Option>
                                                        </Select>
                                                        <span className="monicker" style={{ marginLeft: '10px' }}>表格名称</span>
                                                        <Select
                                                            value={this.state.table_name}
                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                            style={{ width: 250, height: 34 }}
                                                            onChange={(value, option) => {
                                                                console.log(value, "value")
                                                                this.setState({ editloading: true })
                                                                this.SwitchTableName(value)
                                                            }}
                                                        >
                                                            {
                                                                this.state.name_platform == "通用平台" ? <Select.Option value="0">基础产品信息</Select.Option> :
                                                                    userHost.map((item, index) => {
                                                                        return <Select.Option key={index} value={item.subscript}>{item.name}</Select.Option>
                                                                    })
                                                            }
                                                        </Select>
                                                    </div>
                                                </Col>
                                            </Space>
                                            <span style={{ marginLeft: '10px', lineHeight: '50px' }}>
                                                <Button type='primary' onClick={this.showModal}>引用</Button>
                                            </span>
                                        </div>
                                        <Form
                                            ref={this.formRef}
                                            name='base'
                                            labelAlign="left"
                                            layout="inline"
                                            initialValues={this.state.currentlist}
                                            onFinishFailed={this.onFinishFailed}
                                            onFinish={this.onFinish}
                                            onFieldsChange={this.onFieldsChange}
                                        >
                                            {
                                                !editloading && Object.keys(formData).length && Object.keys(sort_data).map((panel, i) => {
                                                    let titles = sort_data[panel];
                                                    
                                                    return <div style={{ width: "100%" }} key={i} id={i}>
                                                        <div style={{ display: "flex" }}>
                                                            <div className='Headline_extra'>
                                                                <p className="triangle"></p>
                                                                <p className="title_of">{panel}</p>
                                                                {
                                                                    panel == "资金清算账户信息" &&
                                                                    <div>
                                                                        <PlusOutlined style={{ marginLeft: "10px" }} />
                                                                        <Select
                                                                            mode="multiple"
                                                                            allowClear
                                                                            style={{ width: '950px', padding: "10px" }}
                                                                            placeholder="可选择填写类型"
                                                                            onChange={this.handleChange}
                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                            value={initialLsit}
                                                                        >
                                                                            <Option key={"托管账户"}>托管账户</Option>
                                                                            <Option key={"认购账户"}>认购账户</Option>
                                                                            <Option key={"申购账户"}>申购账户</Option>
                                                                            <Option key={"分红款账户"}>分红款账户</Option>
                                                                            <Option key={"赎回款账户"}>赎回款账户</Option>
                                                                            <Option key={"认购退款账户"}>认购退款账户</Option>
                                                                        </Select>
                                                                    </div>
                                                                }
                                                                {
                                                                    panel == "联系人信息" &&
                                                                    <div>
                                                                        <PlusOutlined style={{ marginLeft: "10px" }} />
                                                                        <Select
                                                                            mode="multiple"
                                                                            allowClear
                                                                            style={{ width: '950px', padding: "10px" }}
                                                                            placeholder="可选择填写类型"
                                                                            onChange={this.linkman}
                                                                            value={contactList}
                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                        >
                                                                            <Option key={"系统运行"}>系统运行</Option>
                                                                            <Option key={"资金划付"}>资金划付</Option>
                                                                            <Option key={"收入核对"}>收入核对</Option>
                                                                            <Option key={"项目经理"}>项目经理</Option>
                                                                            <Option key={"业务运行"}>业务运行</Option>
                                                                            <Option key={"其他"}>其他</Option>
                                                                            <Option key={"信息披露"}>信息披露</Option>
                                                                            <Option key={"净值"}>净值</Option>
                                                                            <Option key={"信披"}>信披</Option>
                                                                            <Option key={"基金经理"}>基金经理</Option>
                                                                            <Option key={"月报"}>月报</Option>
                                                                        </Select>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {
                                                            (panel !== "资金清算账户信息" && panel !== "联系人信息") ?
                                                                <Descriptions
                                                                    bordered
                                                                    size="middle"
                                                                    style={{ width: '100%' }}
                                                                    key={i}
                                                                    column={2}
                                                                    className="displayContent"
                                                                >
                                                                    {
                                                                        titles.map((title, index) => {
                                                                            return formData[panel][title] &&
                                                                                <Descriptions.Item
                                                                                    className={`label_name ${formData[panel][title].name == "多阶赎回费率详情" ? "full-row-item" : ""}`}
                                                                                    key={index}
                                                                                    span={formData[panel][title].name == "多阶赎回费率详情" ? 2 : 1}
                                                                                    label={
                                                                                        <span>
                                                                                            {formData[panel][title].name}
                                                                                            <font
                                                                                                style={{
                                                                                                    color: 'red',
                                                                                                    fontSize: 18,
                                                                                                    display: (Needlsit.includes(formData[panel][title].field_id) && !(NeedDisable.includes(formData[panel][title].field_id))) ? "inline-block" :
                                                                                                        (formData[panel][title].drequired ? "inline-block " : 'none')
                                                                                                }}
                                                                                            >
                                                                                                *
                                                                                            </font>
                                                                                        </span>
                                                                                    }
                                                                                >
                                                                                    {/* 3:日期选择框 5:时间选择框 6:选择框 8:多选框 10:数值输入框 11:小数点类型 */}
                                                                                    {
                                                                                        formData[panel][title].dinput_type == "3" ?
                                                                                            <Form.Item
                                                                                                name={formData[panel][title].field}
                                                                                                className='query_cycle'
                                                                                                key={index}
                                                                                                rules={[
                                                                                                    {
                                                                                                        required: formData[panel][title].drequired ? true : false,
                                                                                                        message: '该栏为必填项',
                                                                                                    }
                                                                                                ]}
                                                                                            >

                                                                                                <DatePicker
                                                                                                    disabled={formData[panel][title].edit_data ? false : true}
                                                                                                    locale={zhCN}
                                                                                                    bordered={false}
                                                                                                    style={{ width: '100%' }}
                                                                                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                />
                                                                                            </Form.Item>
                                                                                            :
                                                                                            (formData[panel][title].dinput_type == "5" ?
                                                                                                <Form.Item
                                                                                                    name={formData[panel][title].field}
                                                                                                    className='query_cycle'
                                                                                                    key={index}
                                                                                                    rules={[
                                                                                                        {
                                                                                                            required: formData[panel][title].drequired ? true : false,
                                                                                                            message: '该栏为必填项',
                                                                                                        }
                                                                                                    ]}
                                                                                                >
                                                                                                    <DatePicker
                                                                                                        disabled={formData[panel][title].edit_data ? false : true}
                                                                                                        locale={zhCN}
                                                                                                        showTime
                                                                                                        bordered={false}
                                                                                                        style={{ width: '100%' }}
                                                                                                        format="YYYY-MM-DD HH:mm:ss"
                                                                                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                    />
                                                                                                </Form.Item> :
                                                                                                (formData[panel][title].dinput_type == "8" ?
                                                                                                    <Form.Item
                                                                                                        name={formData[panel][title].field}
                                                                                                        className='query_cycle'
                                                                                                        key={index}
                                                                                                        rules={[
                                                                                                            {
                                                                                                                required: formData[panel][title].drequired ? true : false,
                                                                                                                message: '该栏为必填项',
                                                                                                            }
                                                                                                        ]}
                                                                                                    >
                                                                                                        <Select
                                                                                                            mode="multiple"
                                                                                                            allowClear
                                                                                                            style={{ width: '100%' }}
                                                                                                            placeholder={`请选择${formData[panel][title].name}`}
                                                                                                            bordered={false}
                                                                                                        >
                                                                                                            {
                                                                                                                formData[panel][title].options.map(item => {
                                                                                                                    return <Option key={item.value}>{item.label}</Option>
                                                                                                                })
                                                                                                            }
                                                                                                        </Select>
                                                                                                    </Form.Item> :
                                                                                                    (formData[panel][title].dinput_type == "6" ?
                                                                                                        <Form.Item
                                                                                                            name={formData[panel][title].field}
                                                                                                            className='query_cycle'
                                                                                                            key={index}
                                                                                                            rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                        >
                                                                                                            <Select
                                                                                                                // showSearch
                                                                                                                // optionFilterProp="label"
                                                                                                                placeholder={`请选择${formData[panel][title].name}`}
                                                                                                                disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                bordered={false}
                                                                                                                filterOption={(input, option) =>
                                                                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                                                }
                                                                                                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                                onChange={
                                                                                                                    Object.keys(filter_require).includes(formData[panel][title]['field_id']) ?
                                                                                                                        () => this.changeReq(formData[panel][title].field, filter_require[formData[panel][title]['field_id']]) :
                                                                                                                        null
                                                                                                                }
                                                                                                            >
                                                                                                                {
                                                                                                                    formData[panel][title].options.map((item, index) => {
                                                                                                                        return <Select.Option key={index} value={item.value}>{item.label}</Select.Option>
                                                                                                                    })
                                                                                                                }
                                                                                                            </Select>
                                                                                                        </Form.Item>
                                                                                                        :
                                                                                                        ((formData[panel][title].dinput_type == "10" || formData[panel][title].dinput_type == "11") ?
                                                                                                            <Form.Item
                                                                                                                name={formData[panel][title].field}
                                                                                                                className='query_cycle'
                                                                                                                key={index}
                                                                                                                rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                            >
                                                                                                                <InputNumber
                                                                                                                    min={formData[panel][title].numArea ? formData[panel][title].numArea.min : ""}
                                                                                                                    max={formData[panel][title].numArea ? formData[panel][title].numArea.max : ""}
                                                                                                                    disabled={this.state.table_name == '0' && needF.includes(formData[panel][title].field) ? true : NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                    bordered={false}
                                                                                                                    style={{ width: "100%" }}
                                                                                                                    step={
                                                                                                                        (this.state.table_name == '0' && formData[panel][title].field == 'f50') || (this.state.table_name == '0' && formData[panel][title].field == 'f51') ? '0.00' : ''
                                                                                                                    }
                                                                                                                />
                                                                                                            </Form.Item>
                                                                                                            :
                                                                                                            (formData[panel][title].name == "赎回/强制赎回天数" ?
                                                                                                                <Form.Item
                                                                                                                    name={formData[panel][title].field}
                                                                                                                    className='query_cycle'
                                                                                                                    key={index}
                                                                                                                    rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                                >
                                                                                                                    {/* <InputNumber
                                                                                                                        onChange={(value) => {
                                                                                                                            console.log(value)
                                                                                                                            this.setState({redemption:value})
                                                                                                                        }}
                                                                                                                        min={formData[panel][title].numArea ? formData[panel][title].numArea.min : ""}
                                                                                                                        max={formData[panel][title].numArea ? formData[panel][title].numArea.max : ""}
                                                                                                                        disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                        bordered={false}
                                                                                                                        style={{ width: "100%" }}
                                                                                                                    /> */}
                                                                                                                    <Input
                                                                                                                        key={formData[panel][title]}
                                                                                                                        onChange={(value) => {
                                                                                                                            console.log(value)
                                                                                                                            this.setState({ redemption: value })
                                                                                                                        }}
                                                                                                                        disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                        bordered={false}
                                                                                                                        autoComplete="off"
                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                :
                                                                                                                (formData[panel][title].name == "多阶赎回费率详情" ? 
                                                                                                                <Form.List name={formData[panel][title].field}>
                                                                                                                    {(fields, { add, remove }) => (
                                                                                                                        <div>
                                                                                                                            {fields.map(({ key, name, ...restField }) => (
                                                                                                                                <Space
                                                                                                                                    key={key}
                                                                                                                                    style={{
                                                                                                                                        display: 'flex',
                                                                                                                                        marginBottom: 8,
                                                                                                                                    }}
                                                                                                                                    align="baseline"
                                                                                                                                >
                                                                                                                                    {
                                                                                                                                        formData[panel][title].subtype.map(ele => {
                                                                                                                                            return <div key={ele.field}>
                                                                                                                                                {
                                                                                                                                                    (ele.dinput_type == '11' || ele.dinput_type == '10') &&
                                                                                                                                                    <Form.Item
                                                                                                                                                        {...restField}
                                                                                                                                                        name={[name, ele.field]}
                                                                                                                                                        label={ele.name}
                                                                                                                                                        rules={[
                                                                                                                                                            {
                                                                                                                                                                required: ele.drequired == 1 ? true : false,
                                                                                                                                                                message: `请填写${ele.name}`,
                                                                                                                                                            },
                                                                                                                                                        ]}
                                                                                                                                                        className='query_cycle'
                                                                                                                                                    >
                                                                                                                                                        <InputNumber
                                                                                                                                                            min={0}
                                                                                                                                                            max={ele.name == '赎回费率（%）'? 100 : ''}
                                                                                                                                                            disabled={ele.name == '范围最小值' ? true : ele.name == '赎回费率（%）' ? false : fields.length - 1 == name ? name == 0 ? false :  true : false}
                                                                                                                                                            bordered={false}
                                                                                                                                                            step={ele.dinput_type == '10' ? '0.00' : ''}
                                                                                                                                                        />
                                                                                                                                                    </Form.Item>
                                                                                                                                                }
                                                                                                                                                {
                                                                                                                                                    ele.dinput_type == '0' &&
                                                                                                                                                    <Form.Item
                                                                                                                                                        {...restField}
                                                                                                                                                        name={[name, ele.field]}
                                                                                                                                                        label={ele.name}
                                                                                                                                                        rules={[
                                                                                                                                                            {
                                                                                                                                                                required: ele.drequired == 1 ? true : false,
                                                                                                                                                                message: `请填写${ele.name}`,
                                                                                                                                                            },
                                                                                                                                                        ]}
                                                                                                                                                    >
                                                                                                                                                        <Input
                                                                                                                                                            // key={formData[panel][title]}
                                                                                                                                                            disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                                                            bordered={false}
                                                                                                                                                        />
                                                                                                                                                    </Form.Item>
                                                                                                                                                }
                                                                                                                                                {
                                                                                                                                                     ele.dinput_type == '6' &&
                                                                                                                                                     <Form.Item
                                                                                                                                                         {...restField}
                                                                                                                                                         name={[name, ele.field]}
                                                                                                                                                         label={ele.name}
                                                                                                                                                         rules={[
                                                                                                                                                             {
                                                                                                                                                                 required: ele.drequired == 1 ? true : false,
                                                                                                                                                                 message: `请填写${ele.name}`,
                                                                                                                                                             },
                                                                                                                                                         ]}
                                                                                                                                                         className='query_cycle'
                                                                                                                                                     >
                                                                                                                                                         <Select
                                                                                                                                                            // showSearch
                                                                                                                                                            // optionFilterProp="label"
                                                                                                                                                            placeholder={`请选择${ele.name}`}
                                                                                                                                                            disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                                                            bordered={false}
                                                                                                                                                            filterOption={(input, option) =>
                                                                                                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                                                                                            }
                                                                                                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                                                                            onChange={
                                                                                                                                                                Object.keys(filter_require).includes(formData[panel][title]['field_id']) ?
                                                                                                                                                                    () => this.changeReq(formData[panel][title].field, filter_require[formData[panel][title]['field_id']]) :
                                                                                                                                                                    null
                                                                                                                                                            }
                                                                                                                                                            style={{width:'150px'}}
                                                                                                                                                        >
                                                                                                                                                            {
                                                                                                                                                                ele.options.map((item, index) => {
                                                                                                                                                                    return <Select.Option key={index} value={item.value}>{item.label}</Select.Option>
                                                                                                                                                                })
                                                                                                                                                            }
                                                                                                                                                        </Select>
                                                                                                                                                     </Form.Item>
                                                                                                                                                }
                                                                                                                                            </div>
                                                                                                                                        })
                                                                                                                                    }
                                                                                                                                    <MinusCircleOutlined onClick={() => remove(name)} style={{display: fields.length - 1 == name ? 'block' : 'none'}} />
                                                                                                                                </Space>
                                                                                                                            ))}
                                                                                                                            <Form.Item>
                                                                                                                                <Button
                                                                                                                                    disabled={this.state.table_name == '1' && needF.includes(formData[panel][title].field) ? true : NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                                    type="dashed" 
                                                                                                                                    onClick={() => add()} 
                                                                                                                                    block 
                                                                                                                                    icon={<PlusOutlined />}
                                                                                                                                >
                                                                                                                                </Button>
                                                                                                                            </Form.Item>
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </Form.List>
                                                                                                                :
                                                                                                                <Form.Item
                                                                                                                    name={formData[panel][title].field}
                                                                                                                    className='query_cycle'
                                                                                                                    key={index}
                                                                                                                    rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                                >
                                                                                                                    <Input
                                                                                                                        key={formData[panel][title]}
                                                                                                                        disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                        bordered={false}
                                                                                                                        autoComplete="off"
                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                )
                                                                                                                
                                                                                                            )
                                                                                                        )
                                                                                                    )
                                                                                                )
                                                                                            )
                                                                                    }
                                                                                    {
                                                                                        formData[panel][title].field == "f27" ? <p style={{ color: "#ccc" }}>{"请输入-10至9内的值，1代表T+1日，-1代表T-1日，其余值同理"}</p> :
                                                                                        (formData[panel][title].name == "基金结算货币市场" ? <p style={{ color: "#ccc" }}>提醒：如果通用平台基础产品信息中币种为人民币，则基金结算货币市场必须填写现钞。</p> : 
                                                                                            <p style={{ color: "#ccc" }}>{(formData[panel][title].dinput_type == "10" || formData[panel][title].dinput_type == "11") && formData[panel][title].numArea ? `( ${formData[panel][title].numArea.error} )` : ""}</p>)
                                                                                    }
                                                                                    {
                                                                                        (formData[panel][title].field == "f51" && benchmark) && 
                                                                                        <p style={{color:"red"}}>业绩比较基准（区间高）需大于 业绩比较基准（区间低）！</p>
                                                                                    }
                                                                                    {
                                                                                        (formData[panel][title].field == "f50" && benchmarkBig) && 
                                                                                        <p style={{color:"red"}}>业绩比较基准（区间低）需大于零！</p>
                                                                                    }
                                                                                </Descriptions.Item>
                                                                        })
                                                                    }
                                                                </Descriptions>
                                                                : (panel == "资金清算账户信息" ?
                                                                    <Descriptions
                                                                        bordered
                                                                        size="middle"
                                                                        style={{ width: '100%' }}
                                                                        key={i}
                                                                        column={2}
                                                                        className="displayContent"
                                                                    >
                                                                        {
                                                                            titles.map((title, index) => {
                                                                                return (formData[panel][title] && clearing.includes(formData[panel][title].name)) ?
                                                                                    <Descriptions.Item
                                                                                        className={`label_name ${formData[panel][title].name.includes("大额支付号") ? "full-row-item" : ""}`}
                                                                                        key={index}
                                                                                        span={
                                                                                            formData[panel][title].name.includes("大额支付号") ? 2 : 1
                                                                                        }
                                                                                        label={
                                                                                            <span>
                                                                                                {formData[panel][title].name}
                                                                                                <font
                                                                                                    style={{
                                                                                                        color: 'red',
                                                                                                        fontSize: 18,
                                                                                                        display: NeedDisable.length && Needlsit.includes(formData[panel][title].field_id) &&
                                                                                                            !(NeedDisable.includes(formData[panel][title].field_id)) || (restriction.length && restriction.includes(formData[panel][title].field_id)) ? "inline-block" :
                                                                                                            (formData[panel][title].drequired ? "inline-block " : 'none')
                                                                                                    }}
                                                                                                >
                                                                                                    *
                                                                                                </font>
                                                                                            </span>
                                                                                        }
                                                                                    >
                                                                                        {/* 3:日期选择框 5:时间选择框 6:选择框 8:多选框 10:数值输入框 11:小数点类型 */}
                                                                                        {
                                                                                            formData[panel][title].dinput_type == "3" ?
                                                                                                <Form.Item
                                                                                                    name={formData[panel][title].field}
                                                                                                    className='query_cycle'
                                                                                                    key={index}
                                                                                                    rules={[
                                                                                                        {
                                                                                                            required: formData[panel][title].drequired ? true : false,
                                                                                                            message: '该栏为必填项',
                                                                                                        }
                                                                                                    ]}
                                                                                                >

                                                                                                    <DatePicker
                                                                                                        disabled={formData[panel][title].edit_data ? false : true}
                                                                                                        locale={zhCN}
                                                                                                        bordered={false}
                                                                                                        style={{ width: '100%' }}
                                                                                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                    />
                                                                                                </Form.Item>
                                                                                                :
                                                                                                (formData[panel][title].dinput_type == "5" ?
                                                                                                    <Form.Item
                                                                                                        name={formData[panel][title].field}
                                                                                                        className='query_cycle'
                                                                                                        key={index}
                                                                                                        rules={[
                                                                                                            {
                                                                                                                required: formData[panel][title].drequired ? true : false,
                                                                                                                message: '该栏为必填项',
                                                                                                            }
                                                                                                        ]}
                                                                                                    >
                                                                                                        <DatePicker
                                                                                                            disabled={formData[panel][title].edit_data ? false : true}
                                                                                                            locale={zhCN}
                                                                                                            showTime
                                                                                                            bordered={false}
                                                                                                            style={{ width: '100%' }}
                                                                                                            format="YYYY-MM-DD HH:mm:ss"
                                                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                        />
                                                                                                    </Form.Item> :
                                                                                                    (formData[panel][title].dinput_type == "8" ?
                                                                                                        <Form.Item
                                                                                                            name={formData[panel][title].field}
                                                                                                            className='query_cycle'
                                                                                                            key={index}
                                                                                                            rules={[
                                                                                                                {
                                                                                                                    required: formData[panel][title].drequired ? true : false,
                                                                                                                    message: '该栏为必填项',
                                                                                                                }
                                                                                                            ]}
                                                                                                        >
                                                                                                            <Select
                                                                                                                mode="multiple"
                                                                                                                allowClear
                                                                                                                style={{ width: '100%' }}
                                                                                                                placeholder={`请选择${formData[panel][title].name}`}
                                                                                                                bordered={false}
                                                                                                            >
                                                                                                                {
                                                                                                                    formData[panel][title].options.map(item => {
                                                                                                                        return <Option key={item.value}>{item.label}</Option>
                                                                                                                    })
                                                                                                                }
                                                                                                            </Select>
                                                                                                        </Form.Item> :
                                                                                                        (formData[panel][title].dinput_type == "6" ?
                                                                                                            <Form.Item
                                                                                                                name={formData[panel][title].field}
                                                                                                                className='query_cycle'
                                                                                                                key={index}
                                                                                                                rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                            >
                                                                                                                <Select
                                                                                                                    allowClear={true}
                                                                                                                    placeholder={`请选择${formData[panel][title].name}`}
                                                                                                                    disabled={formData[panel][title].edit_data ? false : true}
                                                                                                                    bordered={false}
                                                                                                                    filterOption={(input, option) =>
                                                                                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                                                    }
                                                                                                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                                    onChange={(e) => { this.changeState(e, formData[panel][title].name) }}
                                                                                                                >
                                                                                                                    {
                                                                                                                        formData[panel][title].options.map((item, index) => {
                                                                                                                            return <Select.Option key={index} value={item.value}>{item.label}</Select.Option>
                                                                                                                        })
                                                                                                                    }
                                                                                                                </Select>
                                                                                                            </Form.Item>
                                                                                                            :
                                                                                                            (formData[panel][title].dinput_type == "10" ?
                                                                                                                <Form.Item
                                                                                                                    name={formData[panel][title].field}
                                                                                                                    className='query_cycle'
                                                                                                                    key={index}
                                                                                                                    rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                                >
                                                                                                                    <InputNumber
                                                                                                                        min={formData[panel][title].numArea ? formData[panel][title].numArea.min : ""}
                                                                                                                        max={formData[panel][title].numArea ? formData[panel][title].numArea.max : ""}
                                                                                                                        disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                        bordered={false}
                                                                                                                        style={{ width: "100%" }}
                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                :
                                                                                                                (formData[panel][title].dinput_type == "11" ?
                                                                                                                    <Form.Item
                                                                                                                        name={formData[panel][title].field}
                                                                                                                        className='query_cycle'
                                                                                                                        key={index}
                                                                                                                        rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                                    >
                                                                                                                        <InputNumber
                                                                                                                            min={formData[panel][title].numArea ? formData[panel][title].numArea.min : ""}
                                                                                                                            max={formData[panel][title].numArea ? formData[panel][title].numArea.max : ""}
                                                                                                                            disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                            bordered={false}
                                                                                                                            style={{ width: "100%" }}
                                                                                                                        />
                                                                                                                    </Form.Item>
                                                                                                                    :
                                                                                                                    <Form.Item
                                                                                                                        name={formData[panel][title].field}
                                                                                                                        className='query_cycle'
                                                                                                                        key={index}
                                                                                                                        rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                                    >
                                                                                                                        <Input
                                                                                                                            key={formData[panel][title]}
                                                                                                                            disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                            bordered={false}
                                                                                                                            autoComplete="off"
                                                                                                                            onChange={(e) => { this.changeState(e.target.value, formData[panel][title].name) }}
                                                                                                                        />
                                                                                                                    </Form.Item>
                                                                                                                )
                                                                                                            )
                                                                                                        )
                                                                                                    )
                                                                                                )
                                                                                        }
                                                                                        {
                                                                                            formData[panel][title].name.includes("大额支付号") ?
                                                                                                <p style={{ color: "#ccc" }}>{"提醒：如果代销机构和托管银行都是招商银行，则大额支付号必须不填写。"}</p> :
                                                                                                <p style={{ color: "#ccc" }}>{(formData[panel][title].dinput_type == "10" || formData[panel][title].dinput_type == "11") && formData[panel][title].numArea ? `( ${formData[panel][title].numArea.error} )` : ""}</p>
                                                                                        }
                                                                                    </Descriptions.Item> : ""
                                                                            })
                                                                        }
                                                                    </Descriptions> :
                                                                    <Descriptions
                                                                        bordered
                                                                        size="middle"
                                                                        style={{ width: '100%' }}
                                                                        key={i}
                                                                        column={2}
                                                                        className="displayContent"
                                                                    >
                                                                        {
                                                                            titles.map((title, index) => {
                                                                                return (formData[panel][title] && contact.includes(formData[panel][title].name)) ?
                                                                                    <Descriptions.Item
                                                                                        className={`label_name ${formData[panel][title].name.includes("邮箱") ? "full-row-item" : ""}`}
                                                                                        key={index}
                                                                                        span={
                                                                                            formData[panel][title].name.includes("邮箱") ? 2 : 1
                                                                                        }
                                                                                        label={
                                                                                            <span>
                                                                                                {formData[panel][title].name}
                                                                                                <font
                                                                                                    style={{
                                                                                                        color: 'red',
                                                                                                        fontSize: 18,
                                                                                                        display: NeedDisable.length && Needlsit.includes(formData[panel][title].field_id) &&
                                                                                                            !(NeedDisable.includes(formData[panel][title].field_id)) || (linkmanList.length && linkmanList.includes(formData[panel][title].field_id)) ? "inline-block" :
                                                                                                            (formData[panel][title].drequired ? "inline-block " : 'none')
                                                                                                    }}
                                                                                                >
                                                                                                    *
                                                                                                </font>
                                                                                            </span>
                                                                                        }
                                                                                    >
                                                                                        {/* 3:日期选择框 5:时间选择框 6:选择框 8:多选框 10:数值输入框 11:小数点类型 */}
                                                                                        {
                                                                                            formData[panel][title].dinput_type == "3" ?
                                                                                                <Form.Item
                                                                                                    name={formData[panel][title].field}
                                                                                                    className='query_cycle'
                                                                                                    key={index}
                                                                                                    rules={[
                                                                                                        {
                                                                                                            required: formData[panel][title].drequired ? true : false,
                                                                                                            message: '该栏为必填项',
                                                                                                        }
                                                                                                    ]}
                                                                                                >

                                                                                                    <DatePicker
                                                                                                        disabled={formData[panel][title].edit_data ? false : true}
                                                                                                        locale={zhCN}
                                                                                                        bordered={false}
                                                                                                        style={{ width: '100%' }}
                                                                                                        getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                    />
                                                                                                </Form.Item>
                                                                                                :
                                                                                                (formData[panel][title].dinput_type == "5" ?
                                                                                                    <Form.Item
                                                                                                        name={formData[panel][title].field}
                                                                                                        className='query_cycle'
                                                                                                        key={index}
                                                                                                        rules={[
                                                                                                            {
                                                                                                                required: formData[panel][title].drequired ? true : false,
                                                                                                                message: '该栏为必填项',
                                                                                                            }
                                                                                                        ]}
                                                                                                    >
                                                                                                        <DatePicker
                                                                                                            disabled={formData[panel][title].edit_data ? false : true}
                                                                                                            locale={zhCN}
                                                                                                            showTime
                                                                                                            bordered={false}
                                                                                                            style={{ width: '100%' }}
                                                                                                            format="YYYY-MM-DD HH:mm:ss"
                                                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                        />
                                                                                                    </Form.Item> :
                                                                                                    (formData[panel][title].dinput_type == "8" ?
                                                                                                        <Form.Item
                                                                                                            name={formData[panel][title].field}
                                                                                                            className='query_cycle'
                                                                                                            key={index}
                                                                                                            rules={[
                                                                                                                {
                                                                                                                    required: formData[panel][title].drequired ? true : false,
                                                                                                                    message: '该栏为必填项',
                                                                                                                }
                                                                                                            ]}
                                                                                                        >
                                                                                                            <Select
                                                                                                                mode="multiple"
                                                                                                                allowClear
                                                                                                                style={{ width: '100%' }}
                                                                                                                placeholder={`请选择${formData[panel][title].name}`}
                                                                                                                bordered={false}
                                                                                                            >
                                                                                                                {
                                                                                                                    formData[panel][title].options.map(item => {
                                                                                                                        return <Option key={item.value}>{item.label}</Option>
                                                                                                                    })
                                                                                                                }
                                                                                                            </Select>
                                                                                                        </Form.Item> :
                                                                                                        (formData[panel][title].dinput_type == "6" ?
                                                                                                            <Form.Item
                                                                                                                name={formData[panel][title].field}
                                                                                                                className='query_cycle'
                                                                                                                key={index}
                                                                                                                rules={[
                                                                                                                    {
                                                                                                                        required: formData[panel][title].drequired ? true : false,
                                                                                                                        message: '该栏为必填项',
                                                                                                                    }
                                                                                                                ]}
                                                                                                            >
                                                                                                                <Select
                                                                                                                    placeholder={`请选择${formData[panel][title].name}`}
                                                                                                                    disabled={formData[panel][title].edit_data ? false : true}
                                                                                                                    // showSearch
                                                                                                                    bordered={false}
                                                                                                                    // optionFilterProp="label"
                                                                                                                    filterOption={(input, option) =>
                                                                                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                                                                    }
                                                                                                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                                                                    onChange={
                                                                                                                        Object.keys(filter_require).includes(formData[panel][title]['field_id']) ?
                                                                                                                            () => this.changeReq(formData[panel][title].field, filter_require[formData[panel][title]['field_id']]) :
                                                                                                                            null
                                                                                                                    }
                                                                                                                >
                                                                                                                    {
                                                                                                                        formData[panel][title].options.map((item, index) => {
                                                                                                                            return <Select.Option value={item.value}>{item.label}</Select.Option>
                                                                                                                        })
                                                                                                                    }
                                                                                                                </Select>
                                                                                                            </Form.Item>
                                                                                                            :
                                                                                                            (formData[panel][title].dinput_type == "10" ?
                                                                                                                <Form.Item
                                                                                                                    name={formData[panel][title].field}
                                                                                                                    className='query_cycle'
                                                                                                                    key={index}
                                                                                                                    rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                                >
                                                                                                                    <InputNumber
                                                                                                                        min={formData[panel][title].numArea ? formData[panel][title].numArea.min : ""}
                                                                                                                        max={formData[panel][title].numArea ? formData[panel][title].numArea.max : ""}
                                                                                                                        disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                        bordered={false}
                                                                                                                        style={{ width: "100%" }}
                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                :
                                                                                                                (formData[panel][title].dinput_type == "11" ?
                                                                                                                    <Form.Item
                                                                                                                        name={formData[panel][title].field}
                                                                                                                        className='query_cycle'
                                                                                                                        key={index}
                                                                                                                        rules={fieldRules[formData[panel][title]['field_id']]}
                                                                                                                    >
                                                                                                                        <InputNumber
                                                                                                                            min={formData[panel][title].numArea ? formData[panel][title].numArea.min : ""}
                                                                                                                            max={formData[panel][title].numArea ? formData[panel][title].numArea.max : ""}
                                                                                                                            disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                            bordered={false}
                                                                                                                            style={{ width: "100%" }}
                                                                                                                        />
                                                                                                                    </Form.Item>
                                                                                                                    :
                                                                                                                    <Form.Item
                                                                                                                        name={formData[panel][title].field}
                                                                                                                        className='query_cycle'
                                                                                                                        key={index}
                                                                                                                        rules={fieldRules[formData[panel][title]['field_id']]}

                                                                                                                    >
                                                                                                                        <Input
                                                                                                                            key={formData[panel][title]}
                                                                                                                            onChange={(e) => { this.inputState(e.target.value, formData[panel][title].name) }}
                                                                                                                            disabled={NeedDisable.includes(formData[panel][title].field_id) ? true : (formData[panel][title].edit_data ? false : true)}
                                                                                                                            bordered={false}
                                                                                                                            autoComplete="off"
                                                                                                                        />
                                                                                                                    </Form.Item>
                                                                                                                )
                                                                                                            )
                                                                                                        )
                                                                                                    )
                                                                                                )
                                                                                        }
                                                                                        <p style={{ color: "#ccc" }}>{(formData[panel][title].dinput_type == "10" || formData[panel][title].dinput_type == "11") && formData[panel][title].numArea ? `( ${formData[panel][title].numArea.error} )` : ""}</p>
                                                                                    </Descriptions.Item> : ""
                                                                            })
                                                                        }
                                                                    </Descriptions>)
                                                        }
                                                    </div>
                                                })
                                            }
                                        </Form>
                                    </div>
                                </div>
                            </Skeleton>
                        </div>
                    </Spin>

                </div>

                {/* 引用数据 */}
                <Modal
                    title="引用项目数据"
                    width={700}
                    visible={isModalVisible}
                    destroyOnClose={true}
                    getContainer={false}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    className="Referencing"
                >
                    <div>
                        <div className='customization'>
                            <p className="triangle"></p>
                            <p className="title_of">项目</p>
                            <Select
                                showSearch
                                style={{ width: "400px" }}
                                placeholder="请选择项目"
                                optionFilterProp="children"
                                onChange={(value, option) => {
                                    // console.log("value", value, option)
                                    this.setState({ BoxType: value })
                                }}
                                value={this.state.BoxType}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {
                                    Object.keys(quoteList).map((item, index) => {
                                        return <Option key={index} value={item}>{quoteList[item]}</Option>
                                    })
                                }
                            </Select>
                            {/* <Select
                                showSearch
                                style={{ width: "400px", marginLeft: "20px" }}
                                placeholder="请选择扩展名称"
                                optionFilterProp="children"
                                onChange={(value) => {
                                    console.log(value, "value");
                                }}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="扩展产品信息">扩展产品信息</Option>
                                <Option value="开放期计划">开放期计划</Option>
                            </Select> */}
                        </div>
                        <span style={{ color: "#D7000F", float: "left", padding: '10px 15px 0 15px' }}>*注: 点击确认后即使用该选中项目的相关数据，填充表单（此操作不可逆）。</span>
                    </div>
                </Modal>

                {/* 重要提醒 */}
                <Modal
                    title="重要提醒"
                    width={700}
                    visible={admonish}
                    destroyOnClose={true}
                    getContainer={false}
                    onOk={this.forgetIt}
                    onCancel={this.abrogate}
                    className="important_reminder"
                >
                    <div>
                        <span style={{ color: "#D7000F", float: "left", padding: '10px 15px 0 15px' }}>*注意：切换其他表格，本界面未提交数据不会被保存，是否切换？</span>
                    </div>
                </Modal>

                {/* 跳转提醒 */}
                <Modal
                    title="跳转提醒"
                    width={700}
                    visible={remindGoto}
                    destroyOnClose={true}
                    getContainer={false}
                    onOk={this.agreeGo}
                    onCancel={this.cancelit}
                    className="important_reminder"
                >
                    <div>
                        <span style={{ color: "#D7000F", float: "left", padding: '10px 15px 0 15px' }}>*注意：当前基础表格修改提交成功，是否切换扩展表？</span>
                    </div>
                </Modal>

                {/* 系统提醒 */}
                <Modal
                    centered={true}
                    className="SystemRemind"
                    visible={this.state.remind}
                    title={`系统提醒`}
                    footer={null}
                    width={700}
                    getContainer={false}
                    destroyOnClose={true}
                    onCancel={() => this.setState((prev, props) => {
                        return { remind: false }
                    })}
                    afterClose={() => {
                        var dom = document.getElementsByTagName("body")[0];
                        dom.style.overflow = 'auto';
                    }}
                >
                    <div>
                        <p style={{ color: "#D7000F", textAlign: "left" }}>提醒：请注意，该项目以下信息上游数据缺失，请在上游数据源补全后继续编辑！</p>
                        {
                            issueList.length ?
                                <div style={{ margin: "10px 0", display: 'flex', flexWrap: 'wrap' }}>
                                    <span>TA: </span>
                                    {
                                        issueList.map((item, index) => {
                                            return <span key={index} style={{ margin: "0 10px 0 0" }}>"{item}"</span>
                                        })
                                    }
                                </div> : null
                        }
                        {
                            TCMPList.length ?
                                <div style={{ margin: "10px 0", display: 'flex', flexWrap: 'wrap' }}>
                                    <span>TCMP: </span>
                                    {
                                        TCMPList.map((item, index) => {
                                            return <span key={index} style={{ margin: "0 10px 0 0" }}>"{item}"</span>
                                        })
                                    }
                                </div> : null
                        }
                        {
                            ThisSystem.length ?
                                <div style={{ margin: "10px 0", display: 'flex', flexWrap: 'wrap' }}>
                                    <span>机构服务平台（本系统）: </span>
                                    {
                                        ThisSystem.map((item, index) => {
                                            return <span key={index} style={{ margin: "0 10px 0 0" }}>"{item}"</span>
                                        })
                                    }
                                </div> : null
                        }
                    </div>
                </Modal>

            </ConfigProvider>
        )
    }
}
export default PagePanel;


// WEBPACK FOOTER //
// app/components/customPage/commissionAgents/PagePanel.jsx